import { Component, OnInit, Inject, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { forkJoin } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormArray, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { PeoplepulseService } from 'app/peoplepulse.service';
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatRadioModule } from '@angular/material/radio';

@Component({
  selector: 'app-create-enrollment-dialog',
  standalone: true,
  templateUrl: './create-enrollment-dialog.component.html',
  styleUrls: ['./create-enrollment-dialog.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule
  ]
})
export class CreateEnrollmentDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  isLinear = true;
  @ViewChild('stepper') stepper!: MatStepper;

  // --- Form groups ---
  firstFormGroup!: FormGroup;
  secondFormGroup!: FormGroup;
  thirdFormGroup!: FormGroup;
  fourthFormGroup!: FormGroup;
  fiveFormGroup!: FormGroup;
  sixFormGroup!: FormGroup;
  sevenFormGroup!: FormGroup;
  eightFormGroup!: FormGroup;

  today: string = '';
  // --- UI state ---
  isStepperVisible = false;
  showEsicUploads = false;
  showPfUploads = false;
  showUploadSection = false;
  // isLinear = false;
  isDisabled = false;
  manpowerData: any = null;
  selectedDesignationManpower: any = null;

  // --- Dropdown data ---
  branch_data: any[] = [];
  pcc_data: any[] = [];
  category_data: any[] = [];
  designation_data: any[] = [];
  PAPLdesignation_data: any[] = [];
  department_data: any[] = [];
  grade_data: any[] = [];
  filtered_grade_data: any[] = [];
  slabDetails: any = null;
  dgd_mappings: any[] = [];
  years: number[] = [];
  state_data: any[] = [];
  presentDistricts: any[] = [];
  permanentDistricts: any[] = [];
  bloodGroups: string[] = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];
  nationality: string[] = ['Indian', 'Foreign'];
  religion: string[] = ['Hindu', 'Muslim', 'Christian', 'Sikh', 'Others'];
  caste: string[] = ['SC', 'ST', 'OBC', 'General'];
  maritalStatus: string[] = ['Married', 'Unmarried', 'Widow', 'Widower'];
  bankNames: string[] = [
    'Bank of Baroda',
    'Bank of India',
    'Central Bank of India',
    'CANARA BANK',
    'Central Bank of India',
    'Indian Bank',
    'Indian Overseas Bank',
    'Punjab & Sind Bank',
    'Punjab National Bank',
    'State Bank of India',
    'UCO Bank',
    'Union Bank of India',
    'Axis Bank Ltd',
    'Bandhan Bank Ltd',
    'CSB Bank Ltd',
    'City Union Bank Ltd',
    'DCB Bank Ltd',
    'Dhanlaxmi Bank Ltd',
    'Federal Bank Ltd',
    'HDFC Bank Ltd',
    'ICICI Bank Ltd',
    'Induslnd Bank Ltd',
    'IDFC First Bank Ltd',
    'Jammu & Kashmir Bank Ltd',
    'Karnataka Bank Ltd',
    'Karur Vysya Bank Ltd',
    'Kotak Mahindra Bank Ltd',
    'Lakshmi Vilas Bank Ltd',
    'Nainital Bank Ltd',
    'Bank of India',
    'RBL Bank Ltd',
    'South Indian Bank Ltd',
    'Tamilnad Mercantile Bank Ltd',
    'YES Bank Ltd',
    'IDBI Bank Ltd',
    'Ujjivan Small Finance Bank',
    'India Post Payment Bank',
    'Chhattisgarh Rajya Gramin Bank',
    'AIRTEL PAYMENTS BANK',
    'FINO PAYMENTS BANK',
    'ODISHA STATE COOPERATIVE BANK',
    'EQUITAS SMALL FINANCE BANK',
    'BANK OF MAHARASHTRA',
    'KERALA GRAMIN BANK',
    'TJSB SAHAKARI BANK LTD',
    'SARASWAT CO-OPERATIVE BANK',
    'ABHYUDAYA CO-OP BANK LTD',
    'GP PARSIK BANK',
    'ANDHRA PRADESH GRAMEENA BANK',
    'DBS BANK INDIA LIMITED',
    'ARYAVART BANK',
    'Other'
  ];
  bloodRelations = [
    'SPOUSE',
    'MOTHER',
    'FATHER',
    'BROTHER',
    'SISTER',
    'UNMARRIED DAUGHTER',
    'SON'
  ];

  // Selected values
  branch_name: any = '';
  pcc_name: any = '';
  category_name: any = '';
  designation_name: any = '';
  papl_designation_name: any = '';
  branch_id: any = '';
  profit_cost_id: any = '';
  category_id: any = '';
  designation_id: any = '';
  PAPLdesignation_id: any = '';

  // --- IDs ---
  temp_emp_id: number | null = null;
  temp_id: number | null = null;
  sameAsPresentAddress: boolean = false;
  is_same_permanent_address: number = 0;
  educationType: string = '';
  qualificationStages: any[] = [];
  isEsic: boolean = false;
  epfEsicSaved = false;
  documentUploadCompleted = false;
  documentBase64: any = {
    qualification: [],
    family: []
  };
  minAge: number | null = null;
  maxAge: number | null = null;
  minDob: string = '';
  maxDob: string = '';
  readonly MIN_PASSPORT_SIZE = 50 * 1024; // 50 KB
  readonly MAX_PASSPORT_SIZE = 100 * 1024; // 100 KB
  readonly MAX_FILE_SIZE_3MB = 3 * 1024 * 1024; // 3 MB
  isEsicCodeReadonly = false;
  isPfCodeReadonly = false;
  selectedQualificationFiles: File[] = [];
  selectedQualificationPreviews: { [index: number]: string } = {};
  selectedFamilyFiles: File[] = [];
  selectedFamilyPreviews: { [index: number]: string } = {};
  selectedMasterDocuments: { [key: string]: File | null } = {
    browse_experience: null,
    browse_passport_photo: null,
    browse_aadhaar: null
  };
  selectedBankDocument: File | null = null;
  selectedNomineeDocument: File | null = null;
  pendingAttendance: boolean = false;
  pendingAttendanceCount: number = 0;
  selectedEpfEsicDocuments: { [key: string]: File | null } = {
    esic_sheet: null,
    form11_sheet: null,
    uan_sheet: null,
    browse_ctc: null
  };
  localFilePreviews: { [key: string]: string } = {};
  qualificationOptions: string[] = [
    'ILLITERATE',
    'BELOW 5TH',
    'BELOW 7TH',
    'NON MATRIC',
    'MATRIC',
    'SENIOR SECONDARY',
    'GRADUATE',
    'BA',
    'BSC',
    'B.COM',
    'POST GRADUATE',
    'ITI ELECTRICIAN',
    'ITI FITTER',
    'ITI WELDER',
    'ITI MECHANICAL',
    'ITI ELECTRONICS',
    'DIPLOMA ELECTRICAL',
    'DIPLOMA MECHANICAL',
    'B.TECH ELECTRICAL',
    'B.TECH MECHANICAL',
    'PGDCA'
  ];
  isExitEmployee: boolean = false;
  isProceed: boolean = false;
  isValidate: boolean = true;
  exitEmployeeInfo: any = {};
  isValidated: boolean = false;
  isValidating: boolean = false;
  wasExitEmployeeAtValidation: boolean = false;
  isBlacklistedEmployee: boolean = false;
  isUpdateMode = false;
  originalBranchId: any | null = null;
  originalProfitCostId: any | null = null;
  originalCategoryId: any | null = null;
  originalDesignationId: any | null = null;
  enrolAadhar: string | null = null;
  enrolDob: any | null = null;
  enrolName: string | null = null;
  isPermanentEmployeeEdit = false;
  isNewAadhar: boolean = false;
  earningsData: any[] = [];
  isOtherBankNameVisible: boolean = false;


  constructor(
    private fb: FormBuilder,
    private peoplepulseService: PeoplepulseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CreateEnrollmentDialogComponent>
  ) {
    this.dialogRef.disableClose = true;
  }

  // --------------------------------------------------------------------------
  // INIT
  // --------------------------------------------------------------------------

  ngOnDestroy(): void {
    Object.values(this.localFilePreviews).forEach(url => {
      if (url) {
        try { URL.revokeObjectURL(url); } catch (e) {}
      }
    });
    Object.values(this.selectedQualificationPreviews).forEach(url => {
      if (url) {
        try { URL.revokeObjectURL(url); } catch (e) {}
      }
    });
    Object.values(this.selectedFamilyPreviews).forEach(url => {
      if (url) {
        try { URL.revokeObjectURL(url); } catch (e) {}
      }
    });
  }

  ngOnInit(): void {
    const todayDate = new Date();
    const yyyy = todayDate.getFullYear();
    const mm = String(todayDate.getMonth() + 1).padStart(2, '0');
    const dd = String(todayDate.getDate()).padStart(2, '0');
    this.today = `${yyyy}-${mm}-${dd}`;

    this.isLinear = true;
    this.initForms();
    this.loadEarnings();
    this.generateYears();
    this.getEmployeeTypeAgeRange();
    if (this.data?.type === 'update') {
      this.isUpdateMode = true;
      this.isStepperVisible = true;
      this.loadDropdownsForEdit(() => {
        this.patchFormData(this.data);
      });
      return;
    }
    if (this.data?.type === 'employee_update') {
      this.isUpdateMode = true;
      this.isStepperVisible = true;
      this.isPermanentEmployeeEdit = true;
      const paplId =
        this.data?.papl_id ||
        this.data?.employee?.papl_id ||
        this.data?.paplId;
      this.loadDropdownsForEdit(() => {
        if (paplId) this.loadEmployeeEditData(paplId);
        else console.error('Employee Edit Error: papl_id not received');
      });
    }
  }

  ngAfterViewInit(): void {
    if (this.data?.type === 'update' || this.data?.type === 'employee_update') {
      this.temp_id = this.data?.temp_id || this.data?.id;
      setTimeout(() => {
        this.stepper.selectedIndex = 1;
        if (this.temp_id) {
          this.loadFamilyData(this.temp_id!);
          this.loadQualificationData(this.temp_id!);
        } else {
          console.warn('temp_id missing, skipping family load');
        }
      });
    }
  }


  // --------------------------------------------------------------------------
  // FORM INITIALIZATION
  // --------------------------------------------------------------------------

  initForms(): void {
    this.firstFormGroup = this.fb.group({
      aadhaar_number: ['', [Validators.required, Validators.pattern(/^[0-9]{12}$/)]],
      dob: [''],
      aadhaar_name: ['']
    });
    this.secondFormGroup = this.fb.group({
      temp_emp_id: [''],
      temp_id: [''],
      dob: ['', [Validators.pattern(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/)]],
      branch_id: ['', Validators.required],
      category_id: ['', Validators.required],
      profit_cost_id: ['', Validators.required],
      designation_id: ['', Validators.required],
      PAPLdesignation_id: [''],
      department_id: ['', Validators.required],
      grade_id: ['', Validators.required],
      aadhaar_number: [''],
      aadhaar_name: [''],
      experience: ['', [Validators.pattern(/^[0-9]{1,2}$/)]],
      browse_experience: [''],
      father_husband_name: [''],
      relation_with_employee: [''],
      gender: [''],
      marital_status: [''],
      mobile_with_adhar: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      whatsapp_number: ['', [Validators.pattern(/^[0-9]{10}$/)]],
      email: [''],
      alternative_email: [''],
      browse_passport_photo: [''],
      browse_aadhaar: [''],
      permanent_addrs: [''],
      permanent_state: [''],
      permanent_district: [''],
      permanent_ps: [''],
      permanent_po: [''],
      permanent_village: [''],
      permanent_block: [''],
      permanent_tehsil: [''],
      permanent_gp: [''],
      permanent_pincode: ['', [Validators.required, Validators.pattern(/^[0-9]{6}$/)]],
      permanent_mobile_number: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      present_address: [''],
      present_state: [''],
      present_district: [''],
      present_ps: [''],
      present_po: [''],
      present_village: [''],
      present_block: [''],
      present_tehsil: [''],
      present_gp: [''],
      present_pincode: ['', [Validators.pattern(/^[0-9]{6}$/)]],
      present_mobile_number: ['', [Validators.pattern(/^[0-9]{10}$/)]],
      blood_group: [''],
      ID_mark_employee: [''],
      nationality: [''],
      religion: [''],
      caste: [''],
      health_insurance_no: ['']
    });

    this.thirdFormGroup = this.fb.group({
      qualifications: this.fb.array([
        this.createQualificationForm()
      ])
    });

    this.fourthFormGroup = this.fb.group({
      name_bank: [''],
      other_bank_name: [{ value: '', disabled: true }],
      name_passbook: [''],
      ifsc: [''],
      bank_account_number: [''],
      name_branch: [''],
      pass_book_photo: ['']
    });

    this.fiveFormGroup = this.fb.group({
      nominee_name: [''],
      nominee_relation: [''],
      nominee_dob: [''],
      nominee_aadhaar_number: ['', [Validators.pattern(/^[0-9]{12}$/)]],
      nominee_aadhaar_photo: [''],
      nominee_address: ['']
    });

    this.sixFormGroup = this.fb.group({
      families: this.fb.array([this.createFamilyForm()])
    });

    this.sevenFormGroup = this.fb.group({
      esic_code: [''],
      esic_ip_number: [''],
      wca_gpa: [''],
      wca_gpa_expire_date: [''],
      esic_sheet: [''],
      esic_date: [''],
      esic_type: ['1'],
      pf_code: [''],
      uan: ['', [Validators.pattern(/^[0-9]{12}$/)]],
      pf_account_number: [''],
      form11_sheet: [''],
      uan_sheet: [''],
      browse_ctc: [''],
      epf_date: [''],
      epf_rule: [''],
      pf_type: ['1'],
      esic_status: [false],
      pf_status: [false],
      ctc_details: this.fb.array([])
    });

    this.eightFormGroup = this.fb.group({
      additional_documents: this.fb.array([])
    });
  }

  createQualificationForm(
    qualification: string = ''
  ): FormGroup {

    return this.fb.group({
      university_board_name: [''],
      college_institute_name: [''],
      year_of_passout: [''],
      division_percent: [''],
      qualification: [qualification],
      qualification_document: ['']
    });
  }

  get qualifications(): FormArray {
    return this.thirdFormGroup.get('qualifications') as FormArray;
  }

  get additionalDocuments(): FormArray {
    return this.eightFormGroup.get('additional_documents') as FormArray;
  }

  addQualification(): void {

    this.qualifications.push(
      this.createQualificationForm()
    );

  }

  removeQualification(index: number): void {

    if (this.qualifications.length <= 1) {
      return;
    }

    this.qualifications.removeAt(index);

    // Keep selected files aligned with FormArray indexes
    this.selectedQualificationFiles.splice(index, 1);

  }

  createAdditionalDocument(): FormGroup {
    return this.fb.group({
      document_type: [''],
      document_name: [''],
      document: ['']
    });
  }

  addAdditionalDocument(): void {
    this.additionalDocuments.push(
      this.createAdditionalDocument()
    );
  }

  removeAdditionalDocument(index: number): void {
    this.additionalDocuments.removeAt(index);
  }

  onAdditionalDocumentSelected(
    event: Event,
    index: number
  ): void {

    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    const file = input.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      this.additionalDocuments.at(index).patchValue({
        document_name: file.name,
        document: reader.result
      });
    };
    reader.readAsDataURL(file);
  }

  loadQualificationData(temp_id: number): void {
    if (this.data?.type === 'employee_edit') return;
    if (!temp_id) return;
    this.peoplepulseService.getQualificationByTempId(temp_id).subscribe({
      next: (res: any) => {
        const qualificationsArr = Array.isArray(res.data) ? res.data : res.data?.qualifications ?? [];
        const qa = this.qualifications;
        while (qa.length) qa.removeAt(0);
        if (qualificationsArr.length) {
          qualificationsArr.forEach((q: any) => {
            const g = this.createQualificationForm();
            g.patchValue({
              university_board_name: q.university_board_name ?? '',
              college_institute_name: q.college_institute_name ?? '',
              year_of_passout: q.year_of_passout ?? '',
              division_percent: q.division_percent ?? '',
              qualification: q.qualification ?? '',
              qualification_document: q.qualification_document ?? ''
            });
            // store filename separately
            (g as any).existingFileName = q.qualification_document ?? null;
            qa.push(g);
          });
        } else {
          qa.push(this.createQualificationForm());
        }
      },
      error: (err) => {
        console.error('Error loading qualifications:', err);
      }
    });
  }


  get families(): FormArray {
    return this.sixFormGroup.get('families') as FormArray;
  }

  createFamilyForm(): FormGroup {
    return this.fb.group({
      family_member: [''],
      family_member_dob: [''],
      family_member_relation: [''],
      family_member_residence: [''],
      family_nominee_aadhaar_photo: ['']
    });
  }

  addFamily(): void {
    this.families.push(this.createFamilyForm());
  }

  removeFamily(index: number): void {

    if (this.families.length <= 1) {
      return;
    }

    this.families.removeAt(index);

    // Keep selected files aligned with FormArray indexes
    this.selectedFamilyFiles.splice(index, 1);
  }

  loadFamilyData(temp_id: number): void {
    if (this.data?.type === 'employee_edit') return;
    if (!temp_id) return;
    this.peoplepulseService.getFamilydetailsByTempId(temp_id).subscribe({
      next: (res: any) => {
        const familyArr = Array.isArray(res.data)
          ? res.data
          : res.data?.families ?? [];
        const fa = this.families;
        while (fa.length) fa.removeAt(0);
        if (familyArr.length) {
          familyArr.forEach((f: any) => {
            const g = this.createFamilyForm();
            g.patchValue({
              family_member: f.family_member ?? '',
              family_member_dob: f.family_member_dob ?? '',
              family_member_relation: f.family_member_relation ?? '',
              family_member_residence: f.family_member_residence ?? '',
              family_nominee_aadhaar_photo: f.family_nominee_aadhaar_photo ?? ''
            });
            (g as any).existingFileName = f.family_nominee_aadhaar_photo ?? null;
            fa.push(g);
          });
        } else {
          fa.push(this.createFamilyForm());
        }
      },
      error: (err) => {
        console.error('Error loading family:', err);
      }
    });
  }

  disableAllForms(): void {
    [
      this.firstFormGroup,
      this.secondFormGroup,
      this.thirdFormGroup,
      this.fourthFormGroup,
      this.fiveFormGroup,
      this.sixFormGroup,
      this.sevenFormGroup
    ].forEach(fg => fg?.disable());
  }

  // --------------------------------------------------------------------------
  // PATCH EXISTING DATA
  // --------------------------------------------------------------------------

  patchFormData(data: any): void {
    if (!data) return;
    if (this.data?.type === 'update' || this.data?.type === 'employee_update') {
      this.originalBranchId = Number(data.branch_id) || null;
      this.originalProfitCostId = Number(data.profit_cost_id) || null;
      this.originalCategoryId = Number(data.category_id) || null;
      this.originalDesignationId = Number(data.designation_id) || null;
    }
    const masterData = { ...data };
    delete masterData.browse_experience;
    delete masterData.browse_passport_photo;
    delete masterData.browse_aadhaar;

    this.secondFormGroup.patchValue({
      temp_id: data.temp_id || '',
      temp_emp_id: data.temp_enrollment_id || '',
      aadhaar_number: data.aadhaar_number || '',
      aadhaar_name: data.aadhaar_name || '',
      dob: data.dob || '',
      branch_id: data.branch_id || '',
      branchname: data.branchname || '',
      profit_cost_id: data.profit_cost_id || '',
      pcc_name: data.pcc_name || '',
      category_id: data.category_id || '',
      designation_id: data.designation_id || '',
      designation_name: data.designation_name || '',
      PAPLdesignation_id: data.PAPLdesignation_id || data.papl_designation_id || '',
      papl_designation_name: data.papl_designation_name || '',
      department_id: data.department_id || '',
      grade_id: data.grade_id || '',
      experience: data.experience || '',
      browse_photo: data.browse_photo || '',
      browse_experience: data.browse_experience || data.browse_photo || '',
      father_husband_name: data.father_husband_name || '',
      relation_with_employee: data.relation_with_employee || '',
      gender: data.gender || '',
      marital_status: data.marital_status || '',
      mobile_with_adhar: data.mobile_with_adhar || '',
      whatsapp_number: data.whatsapp_number || '',
      email: data.email || '',
      alternative_email: data.alternative_email || '',
      browse_passport_photo: data.browse_passport_photo || '',
      browse_aadhaar: data.browse_aadhaar || data.aadhaar_photo || '',
      permanent_addrs: data.permanent_addrs || '',
      permanent_state: data.permanent_state !== null &&
        data.permanent_state !== undefined &&
        data.permanent_state !== ''
        ? Number(data.permanent_state)
        : '',
      permanent_district: data.permanent_district !== null &&
        data.permanent_district !== undefined &&
        data.permanent_district !== ''
        ? Number(data.permanent_district)
        : '',
      permanent_ps: data.permanent_ps || '',
      permanent_po: data.permanent_po || '',
      permanent_village: data.permanent_village || '',
      permanent_block: data.permanent_block || '',
      permanent_tehsil: data.permanent_tehsil || '',
      permanent_gp: data.permanent_gp || '',
      permanent_pincode: data.permanent_pincode?.toString() || '',
      permanent_mobile_number: data.permanent_mobile_number || '',
      present_state: data.present_state !== null &&
        data.present_state !== undefined &&
        data.present_state !== ''
        ? Number(data.present_state)
        : '',
      present_district: data.present_district !== null &&
        data.present_district !== undefined &&
        data.present_district !== ''
        ? Number(data.present_district)
        : '',
      present_address: data.present_address || '',
      present_ps: data.present_ps || '',
      present_po: data.present_po || '',
      present_village: data.present_village || '',
      present_block: data.present_block || '',
      present_tehsil: data.present_tehsil || '',
      present_gp: data.present_gp || '',
      present_pincode: data.present_pincode?.toString() || '',
      present_mobile_number: data.present_mobile_number || '',
      blood_group: data.blood_group || '',
      ID_mark_employee: data.ID_mark_employee || '',
      nationality: data.nationality || '',
      religion: data.religion || '',
      caste: data.caste || '',
      health_insurance_no: data.health_insurance_no || '',
      browse_ctc: data.browse_ctc || '',
      status_approval_log: data.status_approval_log || '',
      comment: data.comment || '',
    });

    this.branch_id = data.branch_id || '';
    this.category_id = data.category_id || '';
    this.profit_cost_id = data.profit_cost_id || '';
    this.designation_id = data.designation_id || '';
    this.PAPLdesignation_id = data.PAPLdesignation_id || data.papl_designation_id || '';
    if (!this.category_id && data.department_id) {
      this.onDepartmentChange(data.department_id);
      if (data.grade_id) {
        this.secondFormGroup.patchValue({ grade_id: Number(data.grade_id) });
        this.onGradeChange(data.grade_id);
      }
    }
    this.restoreAddressDropdowns(data);
    if (this.data?.type === 'update' || this.data?.type === 'employee_update') {
      if (this.branch_id) {
        this.peoplepulseService.getPccByBranch(this.branch_id).subscribe({
          next: (res: any) => {
            this.pcc_data = res.data || res;
            this.secondFormGroup.patchValue({
              branch_id: this.branch_id,
              profit_cost_id: this.profit_cost_id
            });
            this.getPfEsicByBranch(this.branch_id);
          },
          error: (err) => {
            console.error(
              'PCC load error:',
              err
            );
          }
        });
      }
      if (this.category_id) {
        this.peoplepulseService.getCategoryByDesignation(this.category_id).subscribe({
          next: (res: any) => {
            this.designation_data = res.data || res;
            this.secondFormGroup.patchValue({
              category_id: this.category_id,
              designation_id: this.designation_id
            });
            this.checkExistingManpowerCapacity();
            if (data.department_id && this.designation_id) {
              this.filterGradesByDepartmentAndDesignation(data.department_id, this.designation_id);
              if (data.grade_id) {
                this.secondFormGroup.patchValue({ grade_id: Number(data.grade_id) });
                this.onGradeChange(data.grade_id);
              }
            }
          },
          error: (err) => {
            console.error(
              'Designation load error:',
              err
            );
          }
        });
      }
      if (!this.PAPLdesignation_data.length) {
        this.peoplepulseService.getAllPaplDesignation().subscribe({
          next: (res: any) => {
            this.PAPLdesignation_data = res.data || res || [];
            this.secondFormGroup.patchValue({
              PAPLdesignation_id: this.PAPLdesignation_id
            });
          },
          error: (err) => {
            console.error('PAPLdesignation load error:', err);
          }
        });
      } else {
        this.secondFormGroup.patchValue({
          PAPLdesignation_id: this.PAPLdesignation_id
        });
      }
    }


    if (data.qualification) {
      if (Array.isArray(data.qualification) && data.qualification.length) {
        const qa = this.qualifications;
        while (qa.length) qa.removeAt(0);
        data.qualification.forEach((q: any) => {
          const g = this.createQualificationForm();
          g.patchValue({
            university_board_name: q.university_board_name ?? '',
            college_institute_name: q.college_institute_name ?? '',
            year_of_passout: q.year_of_passout ?? '',
            division_percent: q.division_percent ?? '',
            qualification: q.qualification ?? '',
            qualification_document: q.qualification_document ?? ''
          });
          (g as any).existingFileName = q.qualification_document ?? null;
          qa.push(g);
        });
      } else if (!Array.isArray(data.qualification)) {
        const { qualification_document, ...qualificationData } = data.qualification;
        this.thirdFormGroup.patchValue({
          ...qualificationData,
          qualification_document: qualification_document || ''
        });
      }
    }

    if (data.bank_details) {
      const { pass_book_photo, ...bankData } = data.bank_details;
      this.fourthFormGroup.patchValue({
        ...bankData,
        pass_book_photo: data.bank_details?.pass_book_photo || ''
      });
    }

    if (data.bank_details?.name_bank === 'Other') {
      this.fourthFormGroup.get('other_bank_name')?.enable();
      this.fourthFormGroup.get('other_bank_name')?.updateValueAndValidity();
    }

    if (data.nominee) {
      const { nominee_aadhaar_photo, ...nomineeData } = data.nominee;
      this.fiveFormGroup.patchValue({
        ...nomineeData,
        nominee_aadhaar_photo: data.nominee?.nominee_aadhaar_photo || ''
      });
    }

    if (data.family_details) {
      if (Array.isArray(data.family_details) && data.family_details.length) {
        const fa = this.families;
        while (fa.length) fa.removeAt(0);
        data.family_details.forEach((f: any) => {
          const g = this.createFamilyForm();
          g.patchValue({
            family_member: f.family_member ?? '',
            family_member_dob: f.family_member_dob ?? '',
            family_member_relation: f.family_member_relation ?? '',
            family_member_residence: f.family_member_residence ?? '',
            family_nominee_aadhaar_photo: f.family_nominee_aadhaar_photo ?? ''
          });
          (g as any).existingFileName = f.family_nominee_aadhaar_photo ?? null;
          fa.push(g);
        });
      } else if (!Array.isArray(data.family_details)) {
        const { family_nominee_aadhaar_photo, ...familyData } = data.family_details;
        this.sixFormGroup.patchValue({
          ...familyData,
          family_nominee_aadhaar_photo: family_nominee_aadhaar_photo || ''
        });
      }
    }

    if (data.epf_esic) {
      const { form11_sheet, uan_sheet, esic_sheet, ...epfData } = data.epf_esic;
      this.sevenFormGroup.patchValue({
        ...epfData,
        esic_sheet: data.epf_esic?.esic_sheet || '',
        form11_sheet: data.epf_esic?.form11_sheet || '',
        uan_sheet: data.epf_esic?.uan_sheet || '',
        browse_ctc: data.epf_esic?.browse_ctc || data.browse_ctc || ''
      });
      if (epfData.wca_gpa) {
        this.onWcaGpaChange({
          value: epfData.wca_gpa
        });
      }
    }
  }

  onAadhaarChange(): void {
    this.isNewAadhar = false;
    this.isValidated = false;
    this.isProceed = false;
    this.isValidate = true;
    this.isExitEmployee = false;
    this.isBlacklistedEmployee = false;
    this.exitEmployeeInfo = {};
    this.wasExitEmployeeAtValidation = false;
    this.firstFormGroup.patchValue(
      {
        aadhaar_name: '',
        dob: ''
      },
      {
        emitEvent: false
      }
    );
    this.temp_emp_id = null;
    this.temp_id = null;
  }

  onSubmitEmployment(): void {
    if (this.isValidating) return;
    const aadhaarControl = this.firstFormGroup.get('aadhaar_number');
    if (!aadhaarControl?.value || aadhaarControl.hasError('required') || aadhaarControl.hasError('pattern')) {
      aadhaarControl?.markAsTouched();
      alert('Please enter a valid 12-digit Aadhaar number.');
      return;
    }
    if (this.wasExitEmployeeAtValidation) {
      const aadhaarName = this.firstFormGroup.get('aadhaar_name')?.value;
      const dob = this.firstFormGroup.get('dob')?.value;
      if (!aadhaarName) {
        alert('Aadhaar Name is required.');
        return;
      }
      if (!dob) {
        alert('Date of Birth is required.');
        return;
      }
      if (!this.validateEmployeeAge()) return;
    }
    this.validateEmployment();
  }

  private validateEmployment(): void {
    if (this.isValidating) return;
    const aadhaarControl = this.firstFormGroup.get('aadhaar_number');
    if (!aadhaarControl?.value || aadhaarControl.hasError('required') || aadhaarControl.hasError('pattern')) {
      aadhaarControl?.markAsTouched();
      alert('Please enter a valid 12-digit Aadhaar number.');
      return;
    }
    if (this.wasExitEmployeeAtValidation) {
      const aadhaarName = this.firstFormGroup.get('aadhaar_name')?.value;
      const dob = this.firstFormGroup.get('dob')?.value;
      if (!aadhaarName) {
        alert('Aadhaar Name is required.');
        return;
      }
      if (!dob) {
        alert('Date of Birth is required.');
        return;
      }
      if (!this.validateEmployeeAge()) return;
    }
    const payload = this.firstFormGroup.getRawValue();
    this.isValidating = true;
    this.peoplepulseService.createEmployment(payload).subscribe({
      next: (res: any) => {
        this.isValidating = false;
        const data = res?.data || {};
        this.isNewAadhar = (!data?.is_exit && data?.aadhaar_number) ? true : false;
        if (this.isNewAadhar) {
          alert('This Aadhaar number is new to our company');
        }
        this.temp_emp_id = data?.temp_enrollment_id || this.temp_emp_id;
        this.temp_id = data?.id || this.temp_id;
        const isBlacklisted =
          data?.is_blacklisted == 1 ||
          data?.is_blacklisted === true ||
          data?.blacklisted == 1 ||
          data?.blacklisted === true ||
          data?.status_key === 'blacklist' ||
          data?.status_key === 'blacklisted';
        if (isBlacklisted) {
          this.isBlacklistedEmployee = true;
          this.isValidated = false;
          this.isProceed = false;
          this.isValidate = true;
          this.isExitEmployee = false;
          this.exitEmployeeInfo = {};
          this.wasExitEmployeeAtValidation = false;
          this.firstFormGroup.patchValue({
            aadhaar_name: data?.aadhaar_name || '',
            dob: data?.dob || ''
          });
          alert('Black List Employee Not Allowed For Re-enrolment');
          return;
        }
        this.secondFormGroup.patchValue({
          temp_emp_id: this.temp_emp_id || '',
          aadhaar_number: data?.aadhaar_number || payload.aadhaar_number || '',
          aadhaar_name: data?.aadhaar_name || payload.aadhaar_name || '',
          dob: data?.dob || payload.dob || ''
        });
        this.firstFormGroup.patchValue({
          aadhaar_number: data?.aadhaar_number || payload.aadhaar_number || '',
          aadhaar_name: data?.aadhaar_name || payload.aadhaar_name || '',
          dob: data?.dob || payload.dob || ''
        });
        if (Number(data?.is_exit) === 1) {
          this.isExitEmployee = true;
          this.exitEmployeeInfo = data;
          if (!this.wasExitEmployeeAtValidation) {
            this.wasExitEmployeeAtValidation = true;
            this.isValidated = false;
            this.isValidate = true;
            this.isProceed = false;
            this.isExitEmployee = true;
            return;
          }
          this.isValidated = true;
          this.isValidate = false;
          this.isProceed = true;
          this.isExitEmployee = true;
          return;
        }
        this.isExitEmployee = false;
        this.exitEmployeeInfo = {};
        this.wasExitEmployeeAtValidation = false;
        this.isValidated = true;
        this.isValidate = false;
        this.isProceed = true;
      },
      error: (err) => {
        this.isValidating = false;
        console.error('Employment validation failed:', err);
        this.isValidated = false;
        this.isProceed = false;
        this.isValidate = true;
        this.isExitEmployee = false;
        this.isBlacklistedEmployee = false;
        this.exitEmployeeInfo = {};
        this.wasExitEmployeeAtValidation = false;
        const message = err?.error?.message || 'Employee validation failed.';
        alert(message);
      }
    });
  }

  proceedToEnrollment(): void {
    if (this.isBlacklistedEmployee) {
      alert('Black List Employee Not Allowed For Re-enrolment');
      return;
    }
    if (!this.isValidated) {
      alert('Please validate the employee before proceeding.');
      return;
    }
    const aadhaar = this.firstFormGroup.get('aadhaar_number')?.value;
    if (!aadhaar) {
      alert('Please enter Aadhaar number.');
      return;
    }
    const aadhaarName = this.firstFormGroup.get('aadhaar_name')?.value;
    if (!aadhaarName) {
      alert('Aadhaar Name is required.');
      return;
    }
    const dob = this.firstFormGroup.get('dob')?.value;
    if (!dob) {
      alert('Date of Birth is required.');
      return;
    }
    if (!this.validateEmployeeAge()) return;
    this.enrolAadhar = aadhaar;
    this.enrolName = aadhaarName;
    this.enrolDob = dob;
    this.secondFormGroup.patchValue({
      aadhaar_number: aadhaar,
      aadhaar_name: aadhaarName,
      dob: dob
    });
    this.loadDropdowns();
    this.isStepperVisible = true;
  }

  goToNextStep(): void {
    if (this.stepper) {
      if (this.stepper.selected) {
        this.stepper.selected.completed = true;
      }
      this.stepper.next();
    }
  }

  // --- MASTER DETAILS CREATE/UPDATE ---

  onSubmitMaster(): void {
    const deptId = Number(this.secondFormGroup.get('department_id')?.value);
    const gradeId = Number(this.secondFormGroup.get('grade_id')?.value);
    const desigId = Number(this.secondFormGroup.get('designation_id')?.value);

    if (!deptId) {
      alert('Please select Department.');
      return;
    }
    if (!gradeId) {
      alert('Please select Grade.');
      return;
    }
    if (!desigId) {
      alert('Please select Designation.');
      return;
    }

    this.peoplepulseService.getAllDepartmentGradeDesignation().subscribe({
      next: (res: any) => {
        this.dgd_mappings = res.data || res || [];
        const isMapped = this.isDesignationMappedWithDeptGrade(deptId, gradeId, desigId);
        if (!isMapped) {
          alert('Selected Designation is not mapped with the selected Department and Grade. Please complete the mapping first in Department Grade Designation Mapping.');
          return;
        }

        if (this.secondFormGroup.invalid) {
          this.secondFormGroup.markAllAsTouched();
          alert('Please fill all required fields in Master Details.');
          return;
        }

        this.executeMasterSubmit();
      },
      error: (err: any) => {
        console.error('Error fetching department-grade-designation mappings:', err);
        const isMapped = this.isDesignationMappedWithDeptGrade(deptId, gradeId, desigId);
        if (!isMapped) {
          alert('Selected Designation is not mapped with the selected Department and Grade. Please complete the mapping first in Department Grade Designation Mapping.');
          return;
        }

        if (this.secondFormGroup.invalid) {
          this.secondFormGroup.markAllAsTouched();
          alert('Please fill all required fields in Master Details.');
          return;
        }

        this.executeMasterSubmit();
      }
    });
  }

  isDesignationMappedWithDeptGrade(
    deptId: number,
    gradeId: number,
    desigId: number
  ): boolean {
    if (!Array.isArray(this.dgd_mappings) || !this.dgd_mappings.length) {
      return false;
    }

    return this.dgd_mappings.some((m: any) =>
      Number(m.department_id) === Number(deptId) &&
      Number(m.grade_id) === Number(gradeId) &&
      Array.isArray(m.designation_ids) &&
      m.designation_ids.map(Number).includes(Number(desigId))
    );
  }
  isDesignationMappingInvalid(): boolean {
    const deptId = Number(this.secondFormGroup?.get('department_id')?.value);
    const gradeId = Number(this.secondFormGroup?.get('grade_id')?.value);
    const desigId = Number(this.secondFormGroup?.get('designation_id')?.value);

    if (!deptId || !gradeId || !desigId) {
      return false;
    }
    return !this.isDesignationMappedWithDeptGrade(deptId, gradeId, desigId);
  }

  executeMasterSubmit(): void {
    const formData = new FormData();
    const masterData = this.secondFormGroup.getRawValue();
    Object.keys(masterData).forEach((key) => {
      if (['browse_experience', 'browse_photo', 'browse_passport_photo', 'browse_aadhaar'].includes(key)) {
        return;
      }
      if (masterData[key] !== null && masterData[key] !== undefined) formData.append(key, masterData[key].toString());
    });
    formData.append(
      'is_same_permanent_address',
      this.is_same_permanent_address.toString()
    );
    const tempId =
      this.temp_id ||
      masterData.temp_id ||
      this.data?.id ||
      '';
    const tempEmpId =
      this.temp_emp_id ||
      masterData.temp_emp_id ||
      this.data?.temp_enrollment_id ||
      '';
    formData.set(
      'temp_id',
      tempId.toString()
    );
    formData.set(
      'temp_emp_id',
      tempEmpId.toString()
    );
    if ((this.data?.type === 'update' || this.data?.type === 'employee_update') && this.data?.temp_enrollment_id) formData.set('temp_enrollment_id', this.data.temp_enrollment_id.toString());
    const experienceFile = this.selectedMasterDocuments['browse_experience'];
    if (experienceFile) formData.append('browse_experience', experienceFile, experienceFile.name);
    const passportPhotoFile = this.selectedMasterDocuments['browse_passport_photo'];
    if (passportPhotoFile) formData.append('browse_passport_photo', passportPhotoFile, passportPhotoFile.name);
    const aadhaarFile = this.selectedMasterDocuments['browse_aadhaar'];
    if (aadhaarFile) formData.append('browse_aadhaar', aadhaarFile, aadhaarFile.name);
    this.peoplepulseService.createMaster(formData).subscribe({
      next: (res: any) => {
        if (this.data?.type === 'update' || this.data?.type === 'employee_update') {
          alert('Master details updated successfully!');
          this.goToNextStep();
        } else {
          alert('Master details saved successfully!');
          const data = res?.data || {};
          this.temp_id = data?.id || this.temp_id;
          this.temp_emp_id = data?.temp_enrollment_id || this.temp_emp_id;
          this.thirdFormGroup.patchValue({
            temp_id: this.temp_id
          });
          this.fourthFormGroup.patchValue({
            temp_id: this.temp_id
          });
          this.fiveFormGroup.patchValue({
            temp_id: this.temp_id
          });
          this.sixFormGroup.patchValue({
            temp_id: this.temp_id
          });
          this.sevenFormGroup.patchValue({
            temp_id: this.temp_id
          });
          this.eightFormGroup.patchValue({
            temp_id: this.temp_id
          });
          this.goToNextStep();
        }
      },
      error: (err) => {
        console.error('Error saving Master details:', err);
        alert(err?.error?.message || 'Error saving Master details.');
      }
    });
  }

  // --- QUALIFICATION CREATE/UPDATE ---

  onSubmitQualification(): void {
    if (this.thirdFormGroup.invalid) {
      this.thirdFormGroup.markAllAsTouched();
      alert("Please fill all required qualification fields.");
      return;
    }

    if (!this.temp_id) {
      alert("Temp ID not found — please complete previous steps first.");
      return;
    }
    const formData = new FormData();
    formData.append('temp_id', this.temp_id.toString());
    this.qualifications.controls.forEach((q, i) => {
      const qVal = q.value;
      const file = this.selectedQualificationFiles?.[i];
      const existingFileName = (q as any).existingFileName || qVal.qualification_document;
      formData.append(
        `qualifications[${i}][university_board_name]`,
        qVal.university_board_name || ''
      );
      formData.append(
        `qualifications[${i}][college_institute_name]`,
        qVal.college_institute_name || ''
      );
      formData.append(
        `qualifications[${i}][year_of_passout]`,
        qVal.year_of_passout || ''
      );
      formData.append(
        `qualifications[${i}][division_percent]`,
        qVal.division_percent || ''
      );
      formData.append(
        `qualifications[${i}][qualification]`,
        qVal.qualification || ''
      );
      if (!file && existingFileName) formData.append(`qualifications[${i}][existing_document]`, existingFileName);
      if (file) formData.append(`qualification_documents[${i}]`, file, file.name);
    });
    this.peoplepulseService.createQualification(formData).subscribe({
      next: (res: any) => {
        alert(
          this.data?.type === 'update' || this.data?.type === 'employee_update'
            ? 'Qualifications updated successfully!'
            : 'Qualifications saved successfully!'
        );
        this.goToNextStep();
      },
      error: (err) => {
        console.error(
          'Error saving qualifications:',
          err
        );
        alert(
          err?.error?.message ||
          'Error saving qualifications.'
        );
      }
    });
  }

  // --- BANK CREATE/UPDATE ---

  onSubmitBank(): void {
    if (this.fourthFormGroup.invalid) {
      this.fourthFormGroup.markAllAsTouched();
      alert('Please fill all required Bank Details.');
      return;
    }
    if (!this.temp_id) {
      alert('Temp ID not found. Please complete previous steps first.');
      return;
    }
    const formData = new FormData();
    const bankData = this.fourthFormGroup.getRawValue();
    Object.keys(bankData).forEach(key => {
      if (key === 'pass_book_photo') return;
      if (bankData[key] !== null && bankData[key] !== undefined) formData.append(key, bankData[key].toString());
    });
    formData.set('temp_id', this.temp_id.toString());
    if (this.selectedBankDocument) formData.append('pass_book_photo', this.selectedBankDocument, this.selectedBankDocument.name);
    this.peoplepulseService.createBankdetails(formData).subscribe({
      next: (res: any) => {
        if (this.data?.type === 'update' || this.data?.type === 'employee_update') {
          alert('Bank details updated successfully!');
        } else {
          alert('Bank details saved successfully!');
        }
        this.goToNextStep();
      },
      error: (err) => {
        console.error(
          'Error saving Bank details:',
          err
        );
        alert(
          err?.error?.message ||
          'Error saving Bank details.'
        );
      }
    });
  }

  // --- NOMINEE CREATE/UPDATE ---

  onSubmitNominee(): void {
    if (this.fiveFormGroup.invalid) {
      this.fiveFormGroup.markAllAsTouched();
      alert('Please fill all required Nominee Details.');
      return;
    }
    if (!this.temp_id) {
      alert('Temp ID not found. Please complete previous steps first.');
      return;
    }
    const formData = new FormData();
    const nomineeData = this.fiveFormGroup.getRawValue();
    Object.keys(nomineeData).forEach(key => {
      if (key === 'nominee_aadhaar_photo') return;
      if (nomineeData[key] !== null && nomineeData[key] !== undefined) formData.append(key, nomineeData[key].toString());
    });
    formData.set(
      'temp_id',
      this.temp_id.toString()
    );
    if (this.selectedNomineeDocument) {
      formData.append(
        'nominee_aadhaar_photo',
        this.selectedNomineeDocument,
        this.selectedNomineeDocument.name
      );
    }
    this.peoplepulseService.createNomineedetails(formData).subscribe({
      next: (res: any) => {
        if (this.data?.type === 'update' || this.data?.type === 'employee_update')
          alert('Nominee details updated successfully!');
        else
          alert('Nominee details saved successfully!');
        this.goToNextStep();
      },
      error: (err) => {
        console.error(
          'Error saving Nominee details:',
          err
        );
        alert(
          err?.error?.message ||
          'Error saving Nominee details.'
        );
      }
    });
  }

  // --- FAMILY CREATE/UPDATE ---

  onSubmitFamily(): void {
    const familyArray = this.families;
    if (!familyArray.length) {
      alert(
        'Please add at least one family member.'
      );
      return;
    }
    if (!this.temp_id) {
      alert(
        'Temp ID not found — please complete previous steps first.'
      );
      return;
    }
    const formData = new FormData();
    formData.append(
      'temp_id',
      this.temp_id.toString()
    );
    this.families.controls.forEach((f, i) => {
      const fVal = f.getRawValue();
      const existingFileName =
        (f as any).existingFileName || fVal.family_nominee_aadhaar_photo || '';
      const file =
        this.selectedFamilyFiles?.[i];
      formData.append(
        `family_details[${i}][family_member]`,
        fVal.family_member || ''
      );
      formData.append(
        `family_details[${i}][family_member_dob]`,
        fVal.family_member_dob || ''
      );
      formData.append(
        `family_details[${i}][family_member_relation]`,
        fVal.family_member_relation || ''
      );
      formData.append(
        `family_details[${i}][family_member_residence]`,
        fVal.family_member_residence || ''
      );
      if (!file && existingFileName) {
        formData.append(
          `family_details[${i}][existing_document]`,
          existingFileName
        );
      }
      if (file) {
        formData.append(
          `family_documents[${i}]`,
          file,
          file.name
        );
      }
    });
    this.peoplepulseService.createFamilydetails(formData).subscribe({
      next: (res: any) => {
        alert(
          this.data?.type === 'update' || this.data?.type === 'employee_update'
            ? 'Family updated successfully!'
            : 'Family saved successfully!'
        );
        this.goToNextStep();
      },
      error: (err) => {
        console.error(
          'Error saving Family:',
          err
        );
        alert(
          err?.error?.message ||
          'Error saving Family.'
        );
      }
    });
  }

  selectedFiles: { [key: number]: File } = {};

  onFileSelected(event: any, index: number): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFiles[index] = file;
    }
  }

  onFileSelectedFamily(event: any, index: number): void {
    const file = event.target.files?.[0];
    if (file) {
      this.families.at(index).patchValue({
        family_nominee_aadhaar_photo: file.name
      });
    }
  }

  // --- EPF/ESIC CREATE/UPDATE ---

  onSubmitEpfEsic(): void {
    const ctcDetails = this.ctcFormData();
    const basicEarning = ctcDetails.find((ctc: any) => this.isBasicEarning(ctc.attribute_name));
    if (basicEarning) {
      const basicVal = parseFloat(basicEarning.amount);
      if (isNaN(basicVal) || basicVal <= 1) {
        const basicCtrl = this.ctcDetails.controls.find((c: any) =>
          this.isBasicEarning(c.get('attribute_name')?.value)
        )?.get('amount');
        basicCtrl?.markAsTouched();
        basicCtrl?.setErrors({ minBasic: true });
        alert('CTC Basic value should be greater than 1.');
        return;
      }
    }

    // Validate CTC total sum against Grade Slab
    this.ensureSlabDetails(() => {
      const slabCheck = this.isCtcWithinGradeSlab();
      if (!slabCheck.valid) {
        alert(slabCheck.message || 'Total CTC amount is not within the Grade Slab limits.');
        return;
      }

      this.executeEpfEsicSubmit(ctcDetails);
    });
  }

  ensureSlabDetails(callback?: () => void): void {
    if (this.slabDetails) {
      callback?.();
      return;
    }
    const gradeId = Number(this.secondFormGroup?.get('grade_id')?.value);
    if (!gradeId) {
      callback?.();
      return;
    }
    const selected = this.grade_data.find((g: any) => Number(g.grade_id || g.id) === gradeId);
    if (selected?.slab) {
      this.slabDetails = selected.slab;
      callback?.();
    } else {
      this.peoplepulseService.getGradeById(gradeId).subscribe({
        next: (res: any) => {
          this.slabDetails = res?.data?.[0]?.slab || res?.data?.slab || null;
          callback?.();
        },
        error: (err: any) => {
          console.error('Error fetching grade slab for CTC validation:', err);
          callback?.();
        }
      });
    }
  }

  getTotalCtcAmount(): number {
    const ctcList = this.ctcFormData();
    if (!ctcList || !Array.isArray(ctcList)) return 0;
    const total = ctcList.reduce((sum: number, item: any) => {
      const val = parseFloat(item?.amount);
      return sum + (isNaN(val) ? 0 : val);
    }, 0);
    return Math.round(total * 100) / 100;
  }

  isCtcWithinGradeSlab(): { valid: boolean; message?: string; totalCtc: number; minPrice?: number; maxPrice?: number } {
    const totalCtc = this.getTotalCtcAmount();
    if (!this.slabDetails) {
      return { valid: true, totalCtc };
    }

    const minPrice = this.slabDetails.min_price !== undefined && this.slabDetails.min_price !== null && this.slabDetails.min_price !== ''
      ? Number(this.slabDetails.min_price)
      : null;
    const maxPrice = this.slabDetails.max_price !== undefined && this.slabDetails.max_price !== null && this.slabDetails.max_price !== ''
      ? Number(this.slabDetails.max_price)
      : null;

    if (minPrice !== null && !isNaN(minPrice) && totalCtc < minPrice) {
      return {
        valid: false,
        message: `Total CTC amount (₹${totalCtc.toFixed(2)}) is less than the minimum Grade Slab limit (₹${minPrice.toFixed(2)}) for "${this.slabDetails.slab_name}".`,
        totalCtc,
        minPrice,
        maxPrice: maxPrice ?? undefined
      };
    }

    if (maxPrice !== null && !isNaN(maxPrice) && totalCtc > maxPrice) {
      return {
        valid: false,
        message: `Total CTC amount (₹${totalCtc.toFixed(2)}) exceeds the maximum Grade Slab limit (₹${maxPrice.toFixed(2)}) for "${this.slabDetails.slab_name}".`,
        totalCtc,
        minPrice: minPrice ?? undefined,
        maxPrice
      };
    }

    return { valid: true, totalCtc, minPrice: minPrice ?? undefined, maxPrice: maxPrice ?? undefined };
  }

  executeEpfEsicSubmit(ctcDetails: any[]): void {
    if (this.sevenFormGroup.invalid) {
      this.sevenFormGroup.markAllAsTouched();
      alert('Please fill all required EPF / ESIC details.');
      return;
    }
    if (!this.temp_id) {
      alert('Temp ID not found. Please complete previous steps first.');
      return;
    }
    const formData = new FormData();
    const epfEsicData = this.sevenFormGroup.getRawValue();
    Object.keys(epfEsicData).forEach(key => {
      if (['ctc_details', 'esic_sheet', 'form11_sheet', 'uan_sheet', 'browse_ctc'].includes(key)) return;
      if (epfEsicData[key] !== null && epfEsicData[key] !== undefined) formData.append(key, epfEsicData[key].toString());
    });
    formData.set('temp_id', this.temp_id.toString());
    formData.set('profit_cost_id', this.secondFormGroup.getRawValue().profit_cost_id?.toString() || '');
    formData.set('designation_id', this.secondFormGroup.getRawValue().designation_id?.toString() || '');
    formData.set('PAPLdesignation_id', this.secondFormGroup.getRawValue().PAPLdesignation_id?.toString() || '');
    formData.set('department_id', this.secondFormGroup.getRawValue().department_id?.toString() || '');
    formData.set('grade_id', this.secondFormGroup.getRawValue().grade_id?.toString() || '');
    ctcDetails.forEach((ctc: any, index: number) => {
      formData.append(
        `ctc_details[${index}][earning_id]`,
        ctc.earning_id?.toString() || ''
      );
      formData.append(
        `ctc_details[${index}][attribute_name]`,
        ctc.attribute_name || ''
      );
      formData.append(`ctc_details[${index}][amount]`,ctc.amount !== null && ctc.amount !== undefined && ctc.amount !== ''? (Number(ctc.amount) >= 0 ? Number(ctc.amount).toFixed(2) : '0.00'): '0.00'
      );
    });
    const esicSheet = this.selectedEpfEsicDocuments['esic_sheet'];
    if (esicSheet) formData.append('esic_sheet', esicSheet, esicSheet.name);
    const form11Sheet = this.selectedEpfEsicDocuments['form11_sheet'];
    if (form11Sheet) formData.append('form11_sheet', form11Sheet, form11Sheet.name);
    const uanSheet = this.selectedEpfEsicDocuments['uan_sheet'];
    if (uanSheet) formData.append('uan_sheet', uanSheet, uanSheet.name);
    const browseCtc = this.selectedEpfEsicDocuments['browse_ctc'];
    if (browseCtc) {
      formData.append('browse_ctc', browseCtc, browseCtc.name);
    } else if (this.sevenFormGroup.get('browse_ctc')?.value) {
      formData.append('browse_ctc', this.sevenFormGroup.get('browse_ctc')?.value);
    }
    this.peoplepulseService.createEpfesicdetails(formData).subscribe({
      next: (res: any) => {
        alert(
          this.data?.type === 'update' || this.data?.type === 'employee_update'
            ? 'EPF / ESIC details updated successfully!'
            : 'EPF / ESIC details saved successfully!'
        );
        this.goToNextStep();
        this.dialogRef.close(true);
      },
      error: (err) => {
        console.error(
          'Error saving EPF / ESIC details:',
          err
        );
        alert(
          err?.error?.message ||
          'Error saving EPF / ESIC details.'
        );
      }
    });
  }

  ctcFormData(): any[] {
    return this.sevenFormGroup.get('ctc_details')?.value || [];
  }


  // --------------------------------------------------------------------------
  // RESET & DROPDOWNS
  // --------------------------------------------------------------------------

  onReset(): void {
    [
      this.firstFormGroup,
      this.secondFormGroup,
      this.thirdFormGroup,
      this.fourthFormGroup,
      this.fiveFormGroup,
      this.sixFormGroup,
      this.sevenFormGroup,
      this.eightFormGroup
    ].forEach(fg => fg?.reset());
    this.addEarningControls();
    this.temp_emp_id = null;
    this.temp_id = null;
    alert('Form reset complete.');
  }

  loadDropdowns(): void {
    this.peoplepulseService.getAllBranch().subscribe({
      next: res => this.branch_data = res.data || res,
      error: (err) => {
        alert(err.error.message);
        console.error('Branch load error:', err.error.message);
      }
    });
    this.peoplepulseService.getAllCategory().subscribe({
      next: res => this.category_data = res.data || res,
      error: (err) => {
        alert(err.error.message);
        console.error('Category load error:', err.error.message);
      }
    });
    this.peoplepulseService.getAllPaplDesignation().subscribe({
      next: res => this.PAPLdesignation_data = res.data || res,
      error: (err) => {
        alert(err.error.message);
        console.error('PAPLdesignation load error:', err.error.message);
      }
    });
    // Load states for address dropdowns
    this.peoplepulseService.getAllStates().subscribe({
      next: (res: any) => {
        this.state_data = res.data || res;
      },
      error: (err: any) => {
        alert(err.error.message);
      }
    });
    // Load departments
    this.peoplepulseService.getAllDepartments().subscribe({
      next: (res: any) => {
        this.department_data = res.data || res || [];
      },
      error: (err: any) => {
        console.error('Department load error:', err);
      }
    });
    // Load grades
    this.peoplepulseService.getAllGrade().subscribe({
      next: (res: any) => {
        this.grade_data = res.data || res || [];
        this.filtered_grade_data = [];
      },
      error: (err: any) => {
        console.error('Grade load error:', err);
      }
    });
   
    this.peoplepulseService.getAllDepartmentGradeDesignation().subscribe({
      next: (res: any) => {
        this.dgd_mappings = res.data || [];
      },
      error: (err: any) => {
        console.error('DGD mappings load error:', err);
      }
    });
  }
  onBranchChange(branchId: number): void {
    this.branch_name = branchId;
    this.branch_id = branchId;
    this.profit_cost_id = '';
    this.pcc_data = [];
    this.secondFormGroup.patchValue({ branch_id: branchId, profit_cost_id: '' });

    this.peoplepulseService.getPccByBranch(branchId).subscribe({
      next: (res: any) => this.pcc_data = res.data || res,
      error: (err) => {
        alert(err.error.message);
        console.error('PCC load error:', err.error.message);
      }
    });
    this.getPfEsicByBranch(branchId);
  }
  // --- Dependent address dropdown handlers ---
  onPresentStateChange(stateId: number): void {
    if (!stateId) {
      this.presentDistricts = [];
      this.secondFormGroup.patchValue({
        present_district: ''
      });
      return;
    }
    this.peoplepulseService.getStatesByDistrict({ state_id: stateId }).subscribe({
      next: (res: any) => {
        this.presentDistricts = res.data || [];
        this.secondFormGroup.patchValue({
          present_district: ''
        });
      },
      error: (err) => {
        this.presentDistricts = [];
        this.secondFormGroup.patchValue({
          present_district: ''
        });
        alert(err.error?.message || 'Districts not found');
      }
    });
  }

  onPermanentStateChange(stateId: number): void {
    if (!stateId) {
      this.permanentDistricts = [];
      this.secondFormGroup.patchValue({
        permanent_district: ''
      });
      return;
    }
    this.peoplepulseService.getStatesByDistrict({ state_id: stateId }).subscribe({
      next: (res: any) => {
        this.permanentDistricts = res.data || [];
        this.secondFormGroup.patchValue({
          permanent_district: ''
        });
      },
      error: (err) => {
        this.permanentDistricts = [];
        this.secondFormGroup.patchValue({
          permanent_district: ''
        });
        alert(err.error?.message || 'Districts not found');
      }
    });
  }

  onDesignationChange(categoryId: number): void {
    this.selectedDesignationManpower = null;
    this.category_name = categoryId;
    this.category_id = categoryId;
    this.designation_id = '';
    this.designation_data = [];
    this.filtered_grade_data = [];
    this.slabDetails = null;
    this.secondFormGroup.patchValue({
      category_id: categoryId,
      designation_id: '',
      grade_id: ''
    });
    this.peoplepulseService.getCategoryByDesignation(categoryId).subscribe({
      next: (res: any) => this.designation_data = res.data || res,
      error: (err) => {
        alert(err.error?.message || 'Error loading designations');
      }
    });
  }
  onProfitCostChange(profit_cost_id: number): void {
    this.profit_cost_id = profit_cost_id;
    this.secondFormGroup.patchValue({
      profit_cost_id: profit_cost_id
    });
    this.selectedDesignationManpower = null;
    if (!profit_cost_id) {
      this.manpowerData = null;
      this.isDisabled = false;
      return;
    }
    this.pendingAttendance = false;
    this.pendingAttendanceCount = 0;
    forkJoin({
      capacity: this.peoplepulseService.getCapacity(profit_cost_id),
      attendance: this.peoplepulseService.checkAttendanceEnrollment(profit_cost_id)
    }).subscribe({
      next: (res: any) => {
        const capacityData = res.capacity?.data;
        this.manpowerData = capacityData;
        const isSameOriginalPcc = this.isUpdateMode && Number(profit_cost_id) === Number(this.originalProfitCostId);
        let effectiveManpowerLeft = Number(capacityData?.manpower_left_pccc ?? 0);
        if (isSameOriginalPcc) effectiveManpowerLeft += 1;
        const isCapacityDisabled = effectiveManpowerLeft <= 0;
        if (isCapacityDisabled) alert('Please contact administrator/management to increase capacity of Profit Cost Center');
        const isAttendanceDisabled = res.attendance?.pending_attendance === true;
        if (isAttendanceDisabled) {
          this.pendingAttendance = true;
          this.pendingAttendanceCount = res.attendance.employee_count;
          alert(`Please enter attendance of all current employee of Profit Cost Center currently ${res.attendance.employee_count} days remaining`);
        }
        this.isDisabled = isCapacityDisabled || isAttendanceDisabled;
      },
      error: (err: any) => {
        console.error('Error checking profit cost center validations:', err);
      }
    });
  }

  onChange(designationId: number): void {
    this.designation_id = designationId;
    this.secondFormGroup.patchValue({
      designation_id: designationId,
      grade_id: ''
    });
    this.slabDetails = null;

    const deptId = Number(this.secondFormGroup.get('department_id')?.value);
    if (!deptId) {
      alert('Please select Department first.');
      this.secondFormGroup.patchValue({ designation_id: '' });
      this.designation_id = '';
      return;
    }

    if (designationId) {
      this.filterGradesByDepartmentAndDesignation(deptId, designationId);
    } else {
      this.filtered_grade_data = [];
    }

    if (!this.profit_cost_id) {
      this.isDisabled = false;
      return;
    }
    this.peoplepulseService.getCapacity(this.profit_cost_id, designationId).subscribe({
      next: (res: any) => {
        const resdata = res?.data;
        this.selectedDesignationManpower = {
          max: Number(resdata?.total_manpower ?? 0),
          current: Number(resdata?.current_manpower ?? 0),
          left: Number(resdata?.manpower_left ?? 0)
        };
        let effectiveLeft = this.selectedDesignationManpower.left;
        const isSameOriginalAssignment =
          this.isUpdateMode &&
          Number(this.profit_cost_id) === Number(this.originalProfitCostId) &&
          Number(designationId) === Number(this.originalDesignationId);
        if (isSameOriginalAssignment) effectiveLeft += 1;
        this.checkAndDisableByManpowerCapacity(effectiveLeft);
      },
      error: (err: any) => {
        console.error('Designation capacity error:', err);
      }
    });
  }

  checkAndDisableByManpowerCapacity(capacityLeft: any): void {
    const isCapacityDisabled = Number(capacityLeft) <= 0;
    this.isDisabled = isCapacityDisabled;
    if (isCapacityDisabled) {
      alert(
        'Please contact administrator/management to increase capacity of this Designation'
      );
    }
  }

  checkExistingManpowerCapacity(): void {
    if (!this.isUpdateMode) return;
    const profitCostId = Number(this.secondFormGroup.get('profit_cost_id')?.value);
    const designationId = Number(this.secondFormGroup.get('designation_id')?.value);
    if (!profitCostId || !designationId) return;
    forkJoin({
      pccCapacity:
        this.peoplepulseService.getCapacity(profitCostId),
      designationCapacity:
        this.peoplepulseService.getCapacity(
          profitCostId,
          designationId
        )
    }).subscribe({
      next: (res: any) => {
        const pccData = res.pccCapacity?.data;
        const designationData = res.designationCapacity?.data;
        this.manpowerData = pccData;
        this.selectedDesignationManpower = {
          max: Number(designationData?.total_manpower ?? 0),
          current: Number(designationData?.current_manpower ?? 0),
          left: Number(designationData?.manpower_left ?? 0)
        };
        let pccLeft = Number(pccData?.manpower_left_pccc ?? 0);
        let designationLeft = Number(designationData?.manpower_left ?? 0);
        const samePcc = Number(profitCostId) === Number(this.originalProfitCostId);
        const sameDesignation = Number(designationId) === Number(this.originalDesignationId);
        if (samePcc) pccLeft++;
        if (samePcc && sameDesignation) designationLeft++;
        const pccDisabled = pccLeft <= 0;
        const designationDisabled = designationLeft <= 0;
        this.isDisabled = pccDisabled || designationDisabled;
      },
      error: (err: any) => {
        console.error('Update manpower capacity validation failed:', err);
      }
    });
  }

  onDepartmentChange(departmentId: any): void {
    this.secondFormGroup.patchValue({
      department_id: departmentId,
      grade_id: ''
    });
    this.slabDetails = null;

    const desigId = Number(this.secondFormGroup.get('designation_id')?.value);
    if (departmentId && desigId) {
      this.filterGradesByDepartmentAndDesignation(departmentId, desigId);
    } else {
      this.filtered_grade_data = [];
    }
  }

  getMappedGradeIds(departmentId: number, designationId: number): number[] {
    if (!Array.isArray(this.dgd_mappings) || !this.dgd_mappings.length) {
      return [];
    }

    const gradeIds = new Set<number>();

    this.dgd_mappings.forEach((m: any) => {
      if (
        Number(m.department_id) === Number(departmentId) &&
        Array.isArray(m.designation_ids) &&
        m.designation_ids.map(Number).includes(Number(designationId)) &&
        m.grade_id
      ) {
        gradeIds.add(Number(m.grade_id));
      }
    });

    return Array.from(gradeIds);
  }

  filterGradesByDepartmentAndDesignation(departmentId: any, designationId: any): void {
    const deptId = Number(departmentId);
    const desigId = Number(designationId);

    if (!deptId || !desigId) {
      this.filtered_grade_data = [];
      return;
    }

    if (!this.dgd_mappings || this.dgd_mappings.length === 0) {
      this.peoplepulseService.getAllDepartmentGradeDesignation().subscribe({
        next: (res: any) => {
          this.dgd_mappings = res.data || res || [];
          this.applyGradeFilter(deptId, desigId);
        },
        error: (err: any) => {
          console.error('Error fetching DGD mappings:', err);
          this.applyGradeFilter(deptId, desigId);
        }
      });
      return;
    }

    this.applyGradeFilter(deptId, desigId);
  }

  applyGradeFilter(deptId: number, desigId: number): void {
    const mappedGradeIds = this.getMappedGradeIds(deptId, desigId);
    if (mappedGradeIds.length === 0) {
      this.filtered_grade_data = [];
      this.secondFormGroup.patchValue({ grade_id: '' });
      this.slabDetails = null;
      alert('Selected Designation is not mapped with any Grade in this Department. Please configure mapping in Department Grade Designation Mapping.');
      return;
    }

    this.filtered_grade_data = this.grade_data.filter((g: any) =>
      mappedGradeIds.includes(Number(g.grade_id || g.id))
    );

    const currentGradeId = Number(this.secondFormGroup.get('grade_id')?.value);
    if (currentGradeId && !mappedGradeIds.includes(currentGradeId)) {
      this.secondFormGroup.patchValue({ grade_id: '' });
      this.slabDetails = null;
    }
  }

  onGradeChange(gradeId: any): void {
    if (!gradeId) {
      this.secondFormGroup.patchValue({ grade_id: '' });
      this.slabDetails = null;
      return;
    }

    const deptId = Number(this.secondFormGroup.get('department_id')?.value);
    const desigId = Number(this.secondFormGroup.get('designation_id')?.value);
    const selectedGradeId = Number(gradeId);

    if (!deptId || !desigId) {
      alert('Please select Department, Category and Designation first.');
      this.secondFormGroup.patchValue({ grade_id: '' });
      this.slabDetails = null;
      return;
    }

    const isMapped = this.isDesignationMappedWithDeptGrade(deptId, selectedGradeId, desigId);
    if (!isMapped) {
      alert('Selected Grade is not mapped with the selected Department and Designation. Please complete the mapping first in Department Grade Designation Mapping.');
      this.secondFormGroup.patchValue({ grade_id: '' });
      this.slabDetails = null;
      return;
    }

    this.secondFormGroup.patchValue({ grade_id: selectedGradeId });

    const selected = this.grade_data.find((g: any) => Number(g.grade_id || g.id) === selectedGradeId);
    if (selected?.slab) {
      this.slabDetails = selected.slab;
    } else {
      this.peoplepulseService.getGradeById(selectedGradeId).subscribe({
        next: (res: any) => {
          this.slabDetails = res?.data?.[0]?.slab || res?.data?.slab || null;
        },
        error: (err: any) => console.error('Error fetching grade slab:', err)
      });
    }
  }

  generateYears(): void {
    const currentYear = new Date().getFullYear();
    for (let y = currentYear; y >= 1950; y--) this.years.push(y);
  }

  toggleEsicUpload(): void {
    this.showEsicUploads = !this.showEsicUploads;
  }

  togglePfUpload(): void {
    this.showPfUploads = !this.showPfUploads;
  }

  sameAsPresent(event?: any): void {
    const isChecked = event?.checked === true;
    this.sameAsPresentAddress = isChecked;
    this.is_same_permanent_address = isChecked ? 1 : 0;
    if (isChecked) {
      const presentState = this.secondFormGroup.get('present_state')?.value;
      const presentDistrict = this.secondFormGroup.get('present_district')?.value;
      this.secondFormGroup.patchValue({
        permanent_addrs: this.secondFormGroup.get('present_address')?.value,
        permanent_state: presentState,
        permanent_ps: this.secondFormGroup.get('present_ps')?.value,
        permanent_po: this.secondFormGroup.get('present_po')?.value,
        permanent_village: this.secondFormGroup.get('present_village')?.value,
        permanent_block: this.secondFormGroup.get('present_block')?.value,
        permanent_tehsil: this.secondFormGroup.get('present_tehsil')?.value,
        permanent_gp: this.secondFormGroup.get('present_gp')?.value,
        permanent_pincode: this.secondFormGroup.get('present_pincode')?.value,
        permanent_mobile_number: this.secondFormGroup.get('present_mobile_number')?.value
      });
      if (presentState) {
        this.loadDistrictsByState(presentState, (districts: any[]) => {
          this.permanentDistricts = districts;
          this.secondFormGroup.patchValue({
            permanent_district: presentDistrict || ''
          });
        }
        );
      }
      return;
    }
    this.secondFormGroup.patchValue({
      permanent_addrs: '',
      permanent_state: '',
      permanent_district: '',
      permanent_ps: '',
      permanent_po: '',
      permanent_village: '',
      permanent_block: '',
      permanent_tehsil: '',
      permanent_gp: '',
      permanent_pincode: '',
      permanent_mobile_number: ''
    });
    this.permanentDistricts = [];
  }

  closeDialog(): void {
    if (this.epfEsicSaved && !this.documentUploadCompleted) {
      alert('Please complete Document Uploads before closing.');
      return;
    }
    if (this.data?.type === 'update' || this.data?.type === 'employee_update') {
      this.dialogRef.close(true);
    } else {
      this.dialogRef.close(false);
    }
  }

  onBankChange(event: any): void {
    const otherBankControl = this.fourthFormGroup.get('other_bank_name');
    if (event.value === 'Other') {
      otherBankControl?.enable();
      this.isOtherBankNameVisible = true;
      otherBankControl?.setValidators([Validators.required]);
    } else {
      otherBankControl?.reset();
      otherBankControl?.disable();
      this.isOtherBankNameVisible = false;
      otherBankControl?.clearValidators();
    }
    otherBankControl?.updateValueAndValidity();
  }

  validateQualificationWithDOB(): boolean {
    const dob = this.secondFormGroup.get('dob')?.value;
    if (!dob) return true;
    const birthYear = new Date(dob).getFullYear();
    const qualifications = this.qualifications.getRawValue();
    const ageRules: any = {
      '8th Standard': { min: 11, max: 16 },
      '10th Standard': { min: 13, max: 18 },
      '+2 / ITI': { min: 15, max: 20 },
      'Graduation': { min: 17, max: 30 },
      'Post Graduation': { min: 20, max: 35 }
    };
    for (const q of qualifications) {
      if (!q.year_of_passout || !q.qualification) continue;
      const passoutYear = Number(q.year_of_passout);
      const ageAtPassout = passoutYear - birthYear;
      const rule = ageRules[q.qualification];
      if (!rule) continue;
      if (ageAtPassout < rule.min || ageAtPassout > rule.max) {
        alert(
          `${q.qualification} passout year is invalid according to DOB.\n` +
          `Expected age should be between ${rule.min} and ${rule.max} years.\n` +
          `Current age at passout: ${ageAtPassout} years.`
        );
        return false;
      }
    }
    return true;
  }

  validateQualificationYears(): boolean {
    const qualifications = this.qualifications.getRawValue();
    const getYear = (qualification: string) => {
      return qualifications.find((q: any) => q.qualification === qualification)?.year_of_passout;
    };
    const year8 = Number(getYear('8th Standard'));
    const year10 = Number(getYear('10th Standard'));
    const year12 = Number(getYear('+2 / ITI'));
    const grad = Number(getYear('Graduation'));
    const postGrad = Number(getYear('Post Graduation'));
    if (year8 && year10 && year8 >= year10) {
      alert('10th passout year must be greater than 8th passout year');
      return false;
    }
    if (year10 && year12 && year10 >= year12) {
      alert('+2 / ITI passout year must be greater than 10th passout year');
      return false;
    }
    if (year12 && grad && year12 >= grad) {
      alert('Graduation passout year must be greater than +2 / ITI passout year');
      return false;
    }
    if (grad && postGrad && grad >= postGrad) {
      alert('Post Graduation passout year must be greater than Graduation passout year');
      return false;
    }
    return true;
  }

  onWcaGpaChange(event: any): void {
    const esicCodeControl = this.sevenFormGroup.get('esic_code');
    const esicIpControl = this.sevenFormGroup.get('esic_ip_number');
    const esicDateControl = this.sevenFormGroup.get('esic_date');
    if (event.value === 'WCA' || event.value === 'GPA') {
      esicCodeControl?.reset();
      esicIpControl?.reset();
      esicDateControl?.reset();
      esicCodeControl?.disable();
      esicIpControl?.disable();
      esicDateControl?.disable();
    } else {
      esicCodeControl?.enable();
      esicIpControl?.enable();
      esicDateControl?.enable();
      const branchId =
        this.secondFormGroup.get('branch_id')?.value ||
        this.branch_id;
      if (branchId) {
        this.getPfEsicByBranch(branchId);
      }
    }
    esicCodeControl?.updateValueAndValidity();
    esicIpControl?.updateValueAndValidity();
    esicDateControl?.updateValueAndValidity();
  }

  onSubmitDocuments(): void {
    if (this.eightFormGroup.invalid) {
      this.eightFormGroup.markAllAsTouched();
      alert('Passport Photo is mandatory. Please select a Passport Photo.');
      return;
    }
    const payload = {
      temp_id: this.temp_id,
      ...this.eightFormGroup.value
    };
    this.peoplepulseService.saveAllEnrolmentDocs(this.temp_id, payload).subscribe({
      next: (res) => {
        this.documentUploadCompleted = true;
        if (this.data?.type === 'update' || this.data?.type === 'employee_update') {
          alert('Documents updated successfully!');
        } else {
          alert('Documents saved successfully!');
        }
        this.dialogRef.close(true);
      },
      error: (err) => {
        alert(err?.error?.message || 'Error saving Documents.');
        console.error('Error saving Documents:', err);
      }
    });
  }

  validatePassportFile(file: File): boolean {
    const extension = file.name.split('.').pop()?.toLowerCase();
    const allowedExtensions = ['jpg', 'jpeg', 'png'];
    if (!extension || !allowedExtensions.includes(extension)) {
      alert('Passport Photo must be JPG, JPEG or PNG.');
      return false;
    }
    if (file.size < this.MIN_PASSPORT_SIZE || file.size > this.MAX_PASSPORT_SIZE) {
      alert('Passport Photo size must be between 50 KB and 100 KB.');
      return false;
    }
    return true;
  }

  validatePdfFile(file: File, documentName: string): boolean {
    const extension = file.name.split('.').pop()?.toLowerCase();
    if (extension !== 'pdf') {
      alert(`${documentName} must be a PDF file.`);
      return false;
    }
    if (file.size > this.MAX_FILE_SIZE_3MB) {
      alert(`${documentName} size must not exceed 3 MB.`);
      return false;
    }
    return true;
  }

  onDocumentSelected(
    event: any,
    fieldName: string,
    formGroup: FormGroup
  ): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    let isValid = true;
    if (fieldName === 'browse_passport_photo') {
      isValid = this.validatePassportFile(file);
    } else {
      const docLabels: Record<string, string> = {
        browse_experience: 'Experience Certificate',
        browse_photo: 'Experience Certificate',
        browse_aadhaar: 'Aadhaar',
        pass_book_photo: 'Passbook / Cancelled Cheque',
        nominee_aadhaar_photo: 'Nominee Aadhaar',
        esic_sheet: 'ESIC Document',
        form11_sheet: 'Form 11',
        uan_sheet: 'UAN Sheet'
      };
      const label = docLabels[fieldName] || 'Document';
      isValid = this.validatePdfFile(file, label);
    }

    if (!isValid) {
      input.value = '';
      formGroup.patchValue({
        [fieldName]: ''
      });
      if (
        fieldName === 'browse_experience' ||
        fieldName === 'browse_passport_photo' ||
        fieldName === 'browse_aadhaar'
      ) {
        this.selectedMasterDocuments[fieldName] = null;
      }
      if (fieldName === 'pass_book_photo') {
        this.selectedBankDocument = null;
      }
      if (fieldName === 'nominee_aadhaar_photo') {
        this.selectedNomineeDocument = null;
      }
      if (
        fieldName === 'esic_sheet' ||
        fieldName === 'form11_sheet' ||
        fieldName === 'uan_sheet'
      ) {
        this.selectedEpfEsicDocuments[fieldName] = null;
      }
      if (this.localFilePreviews[fieldName]) {
        try {
          URL.revokeObjectURL(this.localFilePreviews[fieldName]);
        } catch (e) {}
        delete this.localFilePreviews[fieldName];
      }
      return;
    }

    formGroup.patchValue({
      [fieldName]: file.name
    });
    if (
      fieldName === 'browse_experience' ||
      fieldName === 'browse_passport_photo' ||
      fieldName === 'browse_aadhaar'
    ) {
      this.selectedMasterDocuments[fieldName] = file;
    }
    if (fieldName === 'pass_book_photo') {
      this.selectedBankDocument = file;
    }
    if (fieldName === 'nominee_aadhaar_photo') {
      this.selectedNomineeDocument = file;
    }
    // EPF / ESIC Documents
    if (
      fieldName === 'esic_sheet' ||
      fieldName === 'form11_sheet' ||
      fieldName === 'uan_sheet'
    ) {
      this.selectedEpfEsicDocuments[fieldName] = file;
    }

    if (this.localFilePreviews[fieldName]) {
      try {
        URL.revokeObjectURL(this.localFilePreviews[fieldName]);
      } catch (e) {}
    }
    this.localFilePreviews[fieldName] = URL.createObjectURL(file);

    console.log('Selected document:', fieldName, file);
  }

  onQualificationDocumentSelected(
    event: any,
    index: number
  ): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    if (!this.validatePdfFile(file, 'Qualification Document')) {
      input.value = '';
      this.qualifications.at(index).patchValue({
        qualification_document: ''
      });
      delete this.selectedQualificationFiles[index];
      if (this.selectedQualificationPreviews[index]) {
        try {
          URL.revokeObjectURL(this.selectedQualificationPreviews[index]);
        } catch (e) {}
        delete this.selectedQualificationPreviews[index];
      }
      return;
    }

    this.selectedQualificationFiles[index] = file;
    this.qualifications.at(index).patchValue({
      qualification_document: file.name
    });
    if (this.selectedQualificationPreviews[index]) {
      try {
        URL.revokeObjectURL(this.selectedQualificationPreviews[index]);
      } catch (e) {}
    }
    this.selectedQualificationPreviews[index] = URL.createObjectURL(file);
  }

  onFamilyDocumentSelected(
    event: any,
    index: number
  ): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    if (!this.validatePdfFile(file, 'Family Member Aadhaar')) {
      input.value = '';
      this.families.at(index).patchValue({
        family_nominee_aadhaar_photo: ''
      });
      delete this.selectedFamilyFiles[index];
      if (this.selectedFamilyPreviews[index]) {
        try {
          URL.revokeObjectURL(this.selectedFamilyPreviews[index]);
        } catch (e) {}
        delete this.selectedFamilyPreviews[index];
      }
      return;
    }

    this.selectedFamilyFiles[index] = file;
    this.families.at(index).patchValue({
      family_nominee_aadhaar_photo: file.name
    });
    if (this.selectedFamilyPreviews[index]) {
      try {
        URL.revokeObjectURL(this.selectedFamilyPreviews[index]);
      } catch (e) {}
    }
    this.selectedFamilyPreviews[index] = URL.createObjectURL(file);
  }

  onCtcDocumentSelected(event: any): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    if (!this.validatePdfFile(file, 'Browse CTC')) {
      input.value = '';
      this.sevenFormGroup.patchValue({ browse_ctc: '' });
      this.selectedEpfEsicDocuments['browse_ctc'] = null;
      if (this.localFilePreviews['browse_ctc']) {
        try {
          URL.revokeObjectURL(this.localFilePreviews['browse_ctc']);
        } catch (e) {}
        delete this.localFilePreviews['browse_ctc'];
      }
      return;
    }

    this.selectedEpfEsicDocuments['browse_ctc'] = file;
    this.sevenFormGroup.patchValue({
      browse_ctc: file.name
    });

    if (this.localFilePreviews['browse_ctc']) {
      try {
        URL.revokeObjectURL(this.localFilePreviews['browse_ctc']);
      } catch (e) {}
    }
    this.localFilePreviews['browse_ctc'] = URL.createObjectURL(file);
  }

  isImageFile(fileOrName: any): boolean {
    if (!fileOrName) return false;
    if (typeof File !== 'undefined' && fileOrName instanceof File) {
      return fileOrName.type.startsWith('image/');
    }
    const filename = typeof fileOrName === 'string' ? fileOrName : fileOrName?.name || '';
    if (!filename) return false;
    const cleanName = filename.split('?')[0].toLowerCase();
    return cleanName.endsWith('.jpg') || cleanName.endsWith('.jpeg') || cleanName.endsWith('.png') || cleanName.endsWith('.gif') || cleanName.endsWith('.webp');
  }

  isPdfFile(fileOrName: any): boolean {
    if (!fileOrName) return false;
    if (typeof File !== 'undefined' && fileOrName instanceof File) {
      return fileOrName.type === 'application/pdf' || fileOrName.name.toLowerCase().endsWith('.pdf');
    }
    const filename = typeof fileOrName === 'string' ? fileOrName : fileOrName?.name || '';
    if (!filename) return false;
    const cleanName = filename.split('?')[0].toLowerCase();
    return cleanName.endsWith('.pdf');
  }

  getFileName(pathOrUrl: string | null | undefined): string {
    if (!pathOrUrl) return '';
    return pathOrUrl.split('/').pop()?.split('?')[0] || pathOrUrl;
  }

  getDocUrl(
    pathOrUrl: string | null | undefined,
    type: 'qualification' | 'experience' | 'passport' | 'aadhaar' |
        'passbook' | 'family' | 'esic' | 'form11' | 'uan' | 'ctc' = 'qualification'
  ): string {
  if (!pathOrUrl) return '';

  if (
    pathOrUrl.startsWith('http://') ||
    pathOrUrl.startsWith('https://') ||
    pathOrUrl.startsWith('blob:') ||
    pathOrUrl.startsWith('data:')
  ) {
    return pathOrUrl;
  }

  const folders: Record<string, string> = {
    qualification: 'qualification_documents',
    family: 'family_documents',
    experience: 'experience',
    passport: 'passport_photo',
    aadhaar: 'aadhaar',
    passbook: 'pass_book',
    esic: 'esic_sheet',
    form11: 'form11_sheet',
    uan: 'uan_sheet',
    ctc: 'browse_ctc'
  };

  const folder = folders[type];

  return `${window.location.origin}/api/storage/temporary_enrollment/${folder}/${pathOrUrl}`;
}

  openDocumentPreview(
    file: File | null | undefined,
    serverFileNameOrUrl: string | null | undefined,
    type: 'qualification' | 'experience' | 'passport' | 'aadhaar' | 'passbook' | 'family' | 'esic' | 'form11' | 'uan' | 'ctc' = 'qualification',
    customBlobUrl?: string
  ): void {
    if (customBlobUrl) {
      window.open(customBlobUrl, '_blank');
      return;
    }
    if (file) {
      const url = URL.createObjectURL(file);
      window.open(url, '_blank');
      return;
    }
    if (serverFileNameOrUrl) {
      const url = this.getDocUrl(serverFileNameOrUrl, type);
      if (url) {
        window.open(url, '_blank');
      }
    }
  }

  submitDocuments(): void {
    if (!this.temp_id) {
      alert('Temporary Enrollment ID not found');
      return;
    }
    const payload = {
      browse_experience: this.documentBase64.browse_experience,
      browse_passport_photo: this.documentBase64.browse_passport_photo,
      browse_aadhaar: this.documentBase64.browse_aadhaar,
      pass_book_photo: this.documentBase64.pass_book_photo,
      nominee_aadhaar_photo: this.documentBase64.nominee_aadhaar_photo,
      esic_sheet: this.documentBase64.esic_sheet,
      form11_sheet: this.documentBase64.form11_sheet,
      uan_sheet: this.documentBase64.uan_sheet,
      qualification: this.documentBase64.qualification,
      family: this.documentBase64.family
    };
    this.peoplepulseService.saveAllEnrolmentDocs(this.temp_id, payload).subscribe({
      next: (res: any) => {
        this.documentUploadCompleted = true;
        alert('Documents uploaded successfully');
        this.dialogRef.close(true);
      },
      error: (err) => {
        alert(err?.error?.message || 'Upload failed');
      }
    });
  }

  getEmployeeTypeAgeRange(): void {
    this.peoplepulseService.getEmployeeTypeAgeRange().subscribe({
      next: (res: any) => {
        if (res?.status && res?.data?.length) {
          console.log('Employee Type Age Range:', res);
          this.minAge = Number(res.data[0].min_age);
          this.maxAge = Number(res.data[0].max_age);
          this.setDobRange();
        } else {
          console.error('Employee age range not found');
        }
      },
      error: (err) => {
        console.error('Error fetching employee age range:', err);
      }
    });
  }

  setDobRange(): void {
    const today = new Date();
    const minDobDate = new Date(today);
    minDobDate.setFullYear(today.getFullYear() - this.maxAge);
    const maxDobDate = new Date(today);
    maxDobDate.setFullYear(today.getFullYear() - this.minAge);
    this.minDob = this.formatDate(minDobDate);
    this.maxDob = this.formatDate(maxDobDate);
  }

  formatDate(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }

  validateEmployeeAge(): boolean {
    const dob = this.firstFormGroup.get('dob')?.value;
    if (!dob) return true;
    if (!/^\d{2}-\d{2}-\d{4}$/.test(dob)) {
      alert('Please enter Date of Birth in DD-MM-YYYY format.');
      return false;
    }
    const [day, month, year] = dob.split('-').map(Number);
    const birthDate = new Date(year, month - 1, day);
    if (birthDate.getFullYear() !== year || birthDate.getMonth() !== month - 1 || birthDate.getDate() !== day) {
      alert('Please enter a valid Date of Birth.');
      return false;
    }
    const today = new Date();
    if (birthDate > today) {
      alert('Date of Birth cannot be in the future.');
      return false;
    }
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) age--;
    if (this.minAge !== null && this.maxAge !== null && (age < this.minAge || age > this.maxAge)) {
      alert(`Employee age must be between ${this.minAge} and ${this.maxAge} years.`);
      return false;
    }
    return true;
  }

  getPfEsicByBranch(branchId: number): void {
    if (!branchId) return;
    this.peoplepulseService.getPfEsicByBranch(branchId).subscribe({
      next: (res: any) => {
        const data = res?.data;
        const esicCode = data?.esic_code || '';
        const pfCode = data?.epf_code || '';
        if (esicCode) {
          this.sevenFormGroup.patchValue({
            esic_code: esicCode
          });
          this.isEsicCodeReadonly = true;
        } else {
          this.isEsicCodeReadonly = false;
        }
        if (pfCode) {
          this.sevenFormGroup.patchValue({
            pf_code: pfCode
          });
          this.isPfCodeReadonly = true;
        } else {
          this.isPfCodeReadonly = false;
        }
      },
      error: (err: any) => {
        console.error('Error loading PF/ESIC codes:', err);
        this.isEsicCodeReadonly = false;
        this.isPfCodeReadonly = false;
      }
    });
  }
  onEsicTypeChange(event: any): void {
    console.log(event.value);
    const esicType = event.value;
    const esicIpControl = this.sevenFormGroup.get('esic_ip_number');
    if (esicType === '0') esicIpControl?.setValidators([Validators.required]);
    else esicIpControl?.clearValidators();
    esicIpControl?.updateValueAndValidity();
  }

  loadEmployeeEditData(paplId: string): void {
    if (!paplId) return;
    this.peoplepulseService.getEnrollmentData(paplId).subscribe({
      next: (res: any) => {
        if (!res?.status) {
          alert(res?.message || 'Unable to load employee details');
          return;
        }
        const employeeData = res?.data;
        if (!employeeData) {
          alert('Employee details not found');
          return;
        }
        this.temp_id = employeeData?.enrollment?.id || this.temp_id;
        this.patchEmployeeEditData(employeeData);
      },
      error: (err: any) => {
        alert(err?.error?.message || 'Failed to load employee details');
      }
    });
  }

  patchEmployeeEditData(data: any): void {
    if (!data) return;
    const enrollment = data.enrollment || null;
    const qualifications = Array.isArray(data.qualification) ? data.qualification : [];
    const bank = data.bank || null;
    const nominee = data.nominee || null;
    const family = Array.isArray(data.family) ? data.family : [];
    const epfEsic = data.epf_esic || null;
    if (enrollment) this.patchEnrollmentForm(enrollment);
    this.patchQualificationData(qualifications);
    if (bank) this.patchBankData(bank);
    if (nominee) this.patchNomineeData(nominee);
    this.patchFamilyData(family);
    if (epfEsic) this.patchEpfEsicData(epfEsic);
    this.isUpdateMode = true;
  }

  patchEnrollmentForm(employee: any): void {
    if (!employee) return;
    this.patchFormData(employee);
    if (this.isPermanentEmployeeEdit) {
      this.secondFormGroup?.get('temp_emp_id')?.patchValue(
        employee?.papl_id ?? ''
      );
    }
    if (this.firstFormGroup) {
      this.firstFormGroup.patchValue(
        {
          aadhaar_number:
            employee?.aadhaar_number || '',

          aadhaar_name:
            employee?.aadhaar_name || '',

          dob:
            employee?.dob || ''
        },
        {
          emitEvent: false
        }
      );

    }
    this.isValidated = true;
    this.isValidate = false;
    this.isProceed = true;
  }

  patchQualificationData(
    qualificationData: any[]
  ): void {
    const qualificationArray = this.qualifications;
    while (qualificationArray.length !== 0) {
      qualificationArray.removeAt(0);
    }
    if (!qualificationData || qualificationData.length === 0) {
      qualificationArray.push(this.createQualificationForm());
      return;
    }
    qualificationData.forEach(
      (qualification: any) => {
        const form = this.createQualificationForm(qualification?.qualification ?? '');
        form.patchValue({
          qualification: qualification?.qualification ?? '',
          university_board_name: qualification?.university_board_name ?? '',
          college_institute_name: qualification?.college_institute_name ?? '',
          year_of_passout: qualification?.year_of_passout ?? '',
          division_percent: qualification?.division_percent ?? ''
        });
        (form as any).existingFileName = qualification?.qualification_document ?? null;
        qualificationArray.push(form);
      }
    );
  }

  patchBankData(bank: any): void {
    if (!bank) return;
    this.fourthFormGroup.patchValue({
      name_bank:
        bank?.name_bank ?? '',
      other_bank_name:
        bank?.other_bank_name ?? '',
      name_passbook:
        bank?.name_passbook ?? '',
      ifsc:
        bank?.ifsc ?? '',
      bank_account_number:
        bank?.bank_account_number ?? '',
      name_branch:
        bank?.name_branch ?? ''
    });
    if (bank?.name_bank === 'Other') this.fourthFormGroup.get('other_bank_name')?.enable();
    else this.fourthFormGroup.get('other_bank_name')?.disable();
    this.setExistingBankDocument(bank?.pass_book_photo);
  }

  patchNomineeData(
    nominee: any
  ): void {
    if (!nominee) return;
    this.fiveFormGroup.patchValue({
      nominee_name:
        nominee?.nominee_name ?? '',
      nominee_relation:
        nominee?.nominee_relation ?? '',
      nominee_dob:
        this.formatApiDate(
          nominee?.nominee_dob
        ),
      nominee_aadhaar_number:
        nominee?.nominee_aadhaar_number ?? '',
      nominee_address:
        nominee?.nominee_address ?? ''
    });
    this.setExistingNomineeDocument(nominee?.nominee_aadhaar_photo);
  }

  patchFamilyData(
    familyData: any[]
  ): void {
    const familyArray = this.families;
    while (familyArray.length !== 0) {
      familyArray.removeAt(0);
    }
    if (!familyData || familyData.length === 0) {
      familyArray.push(this.createFamilyForm());
      return;
    }
    familyData.forEach(
      (family: any) => {
        const form = this.createFamilyForm();
        form.patchValue({
          family_member:
            family?.family_member ?? '',
          family_member_dob:
            this.formatApiDate(
              family?.family_member_dob
            ),
          family_member_relation:
            family?.family_member_relation ?? '',
          family_member_residence:
            family?.family_member_residence ?? ''
        });
        (form as any).existingFileName =
          family?.family_nominee_aadhaar_photo ??
          family?.family_document ??
          null;
        familyArray.push(form);
      }
    );
  }

  patchEpfEsicData(
    epfEsic: any
  ): void {
    if (!epfEsic) return;
    this.sevenFormGroup.patchValue({
      esic_code:
        epfEsic?.esic_code ?? '',
      esic_ip_number:
        epfEsic?.esic_ip_number ?? '',
      wca_gpa:
        epfEsic?.wca_gpa ?? '',
      wca_gpa_expire_date:
        this.formatApiDate(
          epfEsic?.wca_gpa_expire_date
        ),
      esic_date:
        this.formatApiDate(
          epfEsic?.esic_date
        ),
      esic_type:
        epfEsic?.esic_type ??
        '1',
      pf_code:
        epfEsic?.pf_code ?? '',
      uan:
        epfEsic?.uan ?? '',
      pf_account_number:
        epfEsic?.pf_account_number ?? '',
      epf_date:
        this.formatApiDate(
          epfEsic?.epf_date
        ),
      epf_rule:
        epfEsic?.epf_rule ?? '',
      pf_type:
        epfEsic?.pf_type ??
        '1',
      esic_status:
        this.convertToBoolean(
          epfEsic?.esic_status
        ),
      pf_status:
        this.convertToBoolean(
          epfEsic?.pf_status
        ),
      browse_ctc:
        epfEsic?.browse_ctc ??
        this.data?.browse_ctc ??
        ''
    });
    this.setExistingEpfEsicDocuments(epfEsic);
  }

  formatApiDate(
    date: any
  ): string {
    if (!date) return '';
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
    const parsedDate = new Date(date);
    if (isNaN(parsedDate.getTime())) return '';
    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const day = String(parsedDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  convertToBoolean(
    value: any
  ): boolean {
    return (
      value === true ||
      value === 1 ||
      value === '1'
    );
  }

  setExistingMasterDocument(
    key: string,
    fileName: any
  ): void {
    if (!fileName) return;
    (this as any).existingMasterDocuments = (this as any).existingMasterDocuments || {};
    (this as any).existingMasterDocuments[key] = fileName;
  }

  setExistingBankDocument(
    fileName: any
  ): void {
    if (!fileName) return;
    (this as any).existingBankDocument = fileName;
  }

  setExistingNomineeDocument(
    fileName: any
  ): void {
    if (!fileName) return;
    (this as any).existingNomineeDocument = fileName;
  }

  setExistingEpfEsicDocuments(
    data: any
  ): void {
    (this as any).existingEpfEsicDocuments = {
      esic_sheet:
        data?.esic_sheet ?? null,
      form11_sheet:
        data?.form11_sheet ?? null,
      uan_sheet:
        data?.uan_sheet ?? null,
      browse_ctc:
        data?.browse_ctc ?? null
    };
  }

  loadDropdownsForEdit(callback?: () => void): void {
    forkJoin({
      branches:
        this.peoplepulseService.getAllBranch(),
      categories:
        this.peoplepulseService.getAllCategory(),
      paplDesignations:
        this.peoplepulseService.getAllPaplDesignation(),
      states:
        this.peoplepulseService.getAllStates(),
      departments:
        this.peoplepulseService.getAllDepartments(),
      grades:
        this.peoplepulseService.getAllGrade(),
      dgdMappings:
        this.peoplepulseService.getAllDepartmentGradeDesignation()
    }).subscribe({
      next: (response: any) => {
        this.branch_data =
          response.branches?.data ||
          response.branches ||
          [];
        this.category_data =
          response.categories?.data ||
          response.categories ||
          [];
        this.PAPLdesignation_data =
          response.paplDesignations?.data ||
          response.paplDesignations ||
          [];
        this.state_data =
          response.states?.data ||
          response.states ||
          [];
        this.department_data =
          response.departments?.data ||
          response.departments ||
          [];
        this.grade_data =
          response.grades?.data ||
          response.grades ||
          [];
        this.filtered_grade_data = [];
        this.dgd_mappings =
          response.dgdMappings?.data ||
          response.dgdMappings ||
          [];
        callback?.();
      },
      error: (err: any) => {
        alert(err?.error?.message || 'Unable to load dropdown data.');
      }
    });
  }

  private loadDistrictsByState(
    stateId: any,
    callback: (districts: any[]) => void
  ): void {
    if (!stateId) {
      callback([]);
      return;
    }
    this.peoplepulseService.getStatesByDistrict({
      state_id: stateId
    }).subscribe({
      next: (res: any) => {
        callback(
          res?.data || []
        );
      },
      error: (err: any) => {
        callback([]);
      }
    });
  }

  private restoreAddressDropdowns(data: any): void {
    const presentState =
      data?.present_state !== null &&
        data?.present_state !== undefined &&
        data?.present_state !== ''
        ? Number(data.present_state)
        : '';
    const presentDistrict =
      data?.present_district !== null &&
        data?.present_district !== undefined &&
        data?.present_district !== ''
        ? Number(data.present_district)
        : '';
    const permanentState =
      data?.permanent_state !== null &&
        data?.permanent_state !== undefined &&
        data?.permanent_state !== ''
        ? Number(data.permanent_state)
        : '';
    const permanentDistrict =
      data?.permanent_district !== null &&
        data?.permanent_district !== undefined &&
        data?.permanent_district !== ''
        ? Number(data.permanent_district)
        : '';
    const isSameAddress = Number(data?.is_same_permanent_address) === 1;
    this.loadDistrictsByState(
      presentState,
      (districts: any[]) => {
        this.presentDistricts = districts || [];
        this.secondFormGroup.patchValue({
          present_state: presentState,
          present_district: presentDistrict
        });
      }
    );
    if (isSameAddress) {
      this.sameAsPresentAddress = true;
      this.is_same_permanent_address = 1;
      this.loadDistrictsByState(
        presentState,
        (districts: any[]) => {
          this.permanentDistricts = districts || [];
          this.secondFormGroup.patchValue({
            permanent_addrs:
              this.secondFormGroup
                .get('present_address')
                ?.value || '',
            permanent_state:
              presentState,
            permanent_district:
              presentDistrict,
            permanent_ps:
              this.secondFormGroup
                .get('present_ps')
                ?.value || '',
            permanent_po:
              this.secondFormGroup
                .get('present_po')
                ?.value || '',
            permanent_village:
              this.secondFormGroup
                .get('present_village')
                ?.value || '',
            permanent_block:
              this.secondFormGroup
                .get('present_block')
                ?.value || '',
            permanent_tehsil:
              this.secondFormGroup
                .get('present_tehsil')
                ?.value || '',
            permanent_gp:
              this.secondFormGroup
                .get('present_gp')
                ?.value || '',
            permanent_pincode:
              this.secondFormGroup
                .get('present_pincode')
                ?.value || '',
            permanent_mobile_number:
              this.secondFormGroup
                .get('present_mobile_number')
                ?.value || ''
          });
        }
      );
      return;
    }
    this.sameAsPresentAddress = false;
    this.is_same_permanent_address = 0;
    this.loadDistrictsByState(
      permanentState,
      (districts: any[]) => {
        this.permanentDistricts =
          districts || [];
        this.secondFormGroup.patchValue({
          permanent_state: permanentState,
          permanent_district: permanentDistrict
        });
      }
    );
  }

  onDobInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');
    value = value.substring(0, 8);
    if (value.length > 4) {
      value = `${value.substring(0, 2)}-${value.substring(2, 4)}-${value.substring(4)}`;
    } else if (value.length > 2) {
      value = `${value.substring(0, 2)}-${value.substring(2)}`;
    }
    input.value = value;
    this.firstFormGroup.get('dob')?.setValue(value, {
      emitEvent: false
    });
    this.enrolDob = value;
  }

  openDobCalendar(picker: HTMLInputElement): void {
    if (!picker) return;
    const currentDob = this.firstFormGroup.get('dob')?.value;
    if (currentDob && /^\d{2}-\d{2}-\d{4}$/.test(currentDob)) {
      const [day, month, year] = currentDob.split('-');
      picker.value = `${year}-${month}-${day}`;
    }
    if (typeof picker.showPicker === 'function') {
      try {
        picker.showPicker();
        return;
      } catch (e) {}
    }
    try {
      picker.focus();
      picker.click();
    } catch (e) {}
  }

  onDobCalendarChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const val = input.value;
    if (!val) return;
    const parts = val.split('-');
    if (parts.length === 3) {
      const [year, month, day] = parts;
      const formattedDob = `${day}-${month}-${year}`;
      this.firstFormGroup.patchValue({ dob: formattedDob });
      this.firstFormGroup.get('dob')?.markAsDirty();
      this.firstFormGroup.get('dob')?.markAsTouched();
      this.firstFormGroup.get('dob')?.updateValueAndValidity();
      this.enrolDob = formattedDob;
    }
  }

  loadEarnings(): void {
    this.peoplepulseService.getAllEarnings().subscribe({
      next: (response: any) => {
        this.earningsData = (response.data || []).map((earning: any) => ({
          id: earning.id,
          attribute_name: earning.attribute_name
        }));
        this.addEarningControls();
      },
      error: (error) => {
        console.error('Error loading earning data:', error);
      }
    });
  }

  get ctcDetails(): FormArray {
    return this.sevenFormGroup.get('ctc_details') as FormArray;
  }

  isBasicEarning(name: string): boolean {
    if (!name) return false;
    const lower = name.trim().toLowerCase();
    return lower === 'basic' || lower.startsWith('basic') || lower.includes('basic');
  }

  addEarningControls(): void {
    const ctcArray = this.ctcDetails;
    while (ctcArray.length) {
      ctcArray.removeAt(0);
    }
    this.earningsData.forEach((earning: any) => {
      const isBasic = this.isBasicEarning(earning.attribute_name);
      ctcArray.push(
        this.fb.group({
          earning_id: [earning.id],
          attribute_name: [earning.attribute_name],
          amount: [
            '0.00',
            isBasic
              ? [
                  Validators.required,
                  (ctrl: any) => {
                    const val = parseFloat(ctrl.value);
                    return !isNaN(val) && val > 1 ? null : { minBasic: true };
                  }
                ]
              : []
          ]
        })
      );
    });
  }

  preventNegative(event: KeyboardEvent): void {
    if (['-', '+', 'e', 'E'].includes(event.key)) {
      event.preventDefault();
    }
  }

  onCtcFocus(index: number, event: FocusEvent): void {
    const ctrl = this.ctcDetails.at(index)?.get('amount');
    if (!ctrl?.value || Number(ctrl.value) === 0) {
      ctrl.setValue('');
    } else {
      (event.target as HTMLInputElement)?.select();
    }
  }

  formatCtc(index: number): void {
    const group = this.ctcDetails.at(index);
    const ctrl = group?.get('amount');
    const val = parseFloat(ctrl?.value);
    ctrl?.setValue(!isNaN(val) && val >= 0 ? val.toFixed(2) : '0.00');
    ctrl?.markAsTouched();
    ctrl?.updateValueAndValidity();
  }
  
}
